(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = 'function' == typeof require && require;
          if (!f && c) return c(i, !0);
          if (u) return u(i, !0);
          var a = new Error("Cannot find module '" + i + "'");
          throw ((a.code = 'MODULE_NOT_FOUND'), a);
        }
        var p = (n[i] = { exports: {} });
        e[i][0].call(
          p.exports,
          function (r) {
            var n = e[i][1][r];
            return o(n || r);
          },
          p,
          p.exports,
          r,
          e,
          n,
          t
        );
      }
      return n[i].exports;
    }

    for (
      var u = 'function' == typeof require && require, i = 0;
      i < t.length;
      i++
    )
      o(t[i]);
    return o;
  }

  return r;
})()(
  {
    1: [
      function (require, module, exports) {
        module.exports = function (self) {
          const ESCAPE = 'Escape';
          const LEFT_ARROW = 'ArrowLeft';
          const RIGHT_ARROW = 'ArrowRight';

          this.handleKeyDown = function (event) {
            switch (event.code) {
              case ESCAPE:
                self.close();
                break;
              case LEFT_ARROW:
                if (self.data.totalSlides > 1) {
                  self.appendMethods.previousSlideViaButton(self.data.slide);
                }
                break;
              case RIGHT_ARROW:
                if (self.data.totalSlides > 1) {
                  self.appendMethods.nextSlideViaButton(self.data.slide);
                }
                break;
            }
          };
        };
      },
      {}
    ],
    2: [
      function (require, module, exports) {
        module.exports = function (scrollbarWidth) {
          this.addRecompense = function () {
            if (!doesScrollbarHaveWidth()) {
              return;
            }
            document.documentElement.style.marginRight = 0 + 'px';
            const elementsToRecompense = getRecompenseElements();
            if (!elementsToRecompense) return;
            for (let i = 0; i < elementsToRecompense.length; i++) {
              elementsToRecompense[i].style.marginRight = 0 + 'px';
            }
          };

          this.removeRecompense = function () {
            if (!doesScrollbarHaveWidth()) {
              return;
            }
            document.documentElement.style.marginRight = '';
            const elementsToRecompense = getRecompenseElements();
            if (!elementsToRecompense) return;
            for (let i = 0; i < elementsToRecompense.length; i++) {
              elementsToRecompense[i].style.marginRight = '';
            }
          };

          const getRecompenseElements = function () {
            return document.getElementsByClassName('recompense-for-scrollbar');
          };

          const doesScrollbarHaveWidth = function () {
            return !!scrollbarWidth;
          };
        };
      },
      {}
    ],
    3: [
      function (require, module, exports) {
        module.exports = function (data) {
          this.getWidth = function () {
            let outer = document.createElement('div');
            outer.style.visibility = 'hidden';
            outer.style.width = '100px';
            outer.style.msOverflowStyle = 'scrollbar';
            document.body.appendChild(outer);
            let widthNoScroll = outer.offsetWidth;
            outer.style.overflow = 'scroll';
            let inner = document.createElement('div');
            inner.style.width = '100%';
            outer.appendChild(inner);
            let widthWithScroll = inner.offsetWidth;
            outer.parentNode.removeChild(outer);
            data.scrollbarWidth = widthNoScroll - widthWithScroll;
          };
        };
      },
      {}
    ],
    4: [
      function (require, module, exports) {
        module.exports = function (self) {
          const keyboardController = self.keyboardController;

          this.attachListener = function () {
            document.addEventListener(
              'keydown',
              keyboardController.handleKeyDown
            );
          };

          this.removeListener = function () {
            document.removeEventListener(
              'keydown',
              keyboardController.handleKeyDown
            );
          };
        };
      },
      {}
    ],
    5: [
      function (require, module, exports) {
        module.exports = function (self) {
          const DOMObject = require('./utils/DOMObject');
          const loader =
            '<div class="fslightbox-loader"><div></div><div></div><div></div><div></div></div>';
          const data = self.data;
          const elements = self.elements;

          this.runAnimationOnSource = function (elem) {
            elem.firstChild.firstChild.style.animation =
              'fslightbox-' +
              data.animation +
              ' ' +
              data.animationDuration +
              'ms';
          };

          this.clearAnimationOnSource = function (elem) {
            const src = elem.firstChild.firstChild;
            src.style.animation = '';
            void src.offsetWidth;
          };

          this.runFadeOutAnimationOnSource = function (elem) {
            const src = elem.firstChild.firstChild;
            src.style.animation = '';
            void src.offsetWidth;
            src.style.animation =
              'fslightbox-fade-out-anim' +
              ' ' +
              data.animationDuration +
              'ms' +
              ' ease';
            src.style.animationFillMode =
              'fslightbox-fade-out-anim' +
              ' ' +
              data.animationDuration +
              'ms' +
              ' ease';
          };

          const createHolder = function (index) {
            const sourceHolder = new DOMObject('div').addClassesAndCreate([
              'fslightbox-source-holder'
            ]);
            const animationHolder = new DOMObject('div').addClassesAndCreate([
              'fslightbox-animation-holder'
            ]);
            sourceHolder.appendChild(animationHolder);
            animationHolder.innerHTML = loader;
            elements.sources[index] = sourceHolder;
            return sourceHolder;
          };

          this.renderHolderInitial = function (slide) {
            const sourcesIndexes = self.getSourcesIndexes.all(slide);
            const totalSlides = data.totalSlides;

            if (totalSlides >= 3) {
              const prev = createHolder(sourcesIndexes.previous);
              self.transforms.transformMinus(prev);
              elements.mediaHolder.holder.appendChild(prev);
            }
            if (totalSlides >= 1) {
              const curr = createHolder(sourcesIndexes.current);
              elements.mediaHolder.holder.appendChild(curr);
            }
            if (totalSlides >= 2) {
              const next = createHolder(sourcesIndexes.next);
              self.transforms.transformPlus(next);
              elements.mediaHolder.holder.appendChild(next);
            }
          };

          this.renderHolder = function (slide, type) {
            switch (type) {
              case 'previous':
                renderHolderPrevious(slide);
                break;
              case 'current':
                renderHolderCurrent(slide);
                break;
              case 'next':
                renderHolderNext(slide);
                break;
            }
          };

          const renderHolderPrevious = function (slide) {
            const previousSourceIndex = self.getSourcesIndexes.previous(slide);
            const prev = createHolder(previousSourceIndex);
            self.transforms.transformMinus(prev);
            elements.mediaHolder.holder.insertAdjacentElement(
              'afterbegin',
              prev
            );
          };

          const renderHolderNext = function (slide) {
            const nextSourceIndex = self.getSourcesIndexes.next(slide);
            const next = createHolder(nextSourceIndex);
            self.transforms.transformPlus(next);
            elements.mediaHolder.holder.appendChild(next);
          };

          const renderHolderCurrent = function (slide) {
            const sourcesIndexes = self.getSourcesIndexes.all(slide);
            const curr = createHolder(sourcesIndexes.current);
            self.transforms.transformNull(curr);
            elements.mediaHolder.holder.insertBefore(
              curr,
              elements.sources[sourcesIndexes.next]
            );
          };

          const slideViaButtonAndReturnNewIndexes = function (
            previousSlide,
            type
          ) {
            self.caption.switchCaptions(type);
            if (self.data.thumbnails && self.thumbnails.areThumbnailsFadedOut) {
              self.thumbnails.fadeInThumbnails();
            }

            if (type === 'previous') {
              if (previousSlide === 1) {
                data.slide = data.totalSlides;
              } else {
                data.slide -= 1;
              }
            } else {
              if (previousSlide === data.totalSlides) {
                data.slide = 1;
              } else {
                data.slide += 1;
              }
            }
            self.othersMethods.updateSlideNumber(data.slide);
            if (data.thumbnails) {
              self.thumbnails.thumbnailsLogic.switchThumbnailOnSlideChange(
                previousSlide,
                data.slide
              );
            }
            self.afterSlideChange();
            return self.getSourcesIndexes.all(data.slide);
          };

          this.previousSlideViaButton = function (previousSlide) {
            const newSourcesIndexes = slideViaButtonAndReturnNewIndexes(
              previousSlide,
              'previous'
            );

            if (
              typeof elements.sources[newSourcesIndexes.previous] ===
              'undefined'
            ) {
              self.createSources('previous');
            }

            const sources = elements.sources;
            const currentSource = sources[newSourcesIndexes.current];
            const nextSource = sources[newSourcesIndexes.next];

            this.clearAnimationOnSource(currentSource);
            this.runAnimationOnSource(currentSource);
            this.runFadeOutAnimationOnSource(nextSource);

            self.transforms.transformNull(currentSource);
            setTimeout(function () {
              if (newSourcesIndexes.next !== data.slide - 1) {
                self.transforms.transformPlus(nextSource);
              }
            }, data.animationDuration - 30);
          };

          this.nextSlideViaButton = function (previousSlide) {
            const newSourcesIndexes = slideViaButtonAndReturnNewIndexes(
              previousSlide,
              'next'
            );

            if (
              typeof elements.sources[newSourcesIndexes.next] === 'undefined'
            ) {
              self.createSources('next');
            }

            const sources = elements.sources;
            const currentSource = sources[newSourcesIndexes.current];
            const previousSource = sources[newSourcesIndexes.previous];

            this.clearAnimationOnSource(currentSource);
            this.runAnimationOnSource(currentSource);
            this.runFadeOutAnimationOnSource(previousSource);

            self.transforms.transformNull(currentSource);
            setTimeout(function () {
              if (newSourcesIndexes.previous !== data.slide - 1) {
                self.transforms.transformMinus(previousSource);
              }
            }, data.animationDuration - 30);
          };
        };
      },
      { './utils/DOMObject': 25 }
    ],
    6: [
      function (require, module, exports) {
        module.exports = function (self) {
          const data = self.data;
          const elements = self.elements;
          const _this = this;
          const CURSOR_GRABBING_CLASS_NAME = 'fslightbox-cursor-grabbing';

          //we will hover all windows with div with high z-index to be sure mouseup is triggered
          this.invisibleHover = new (require('./utils/DOMObject'))(
            'div'
          ).addClassesAndCreate(['fslightbox-invisible-hover']);

          /**
           * mediaHolder invisibleHolder and holderWrapper
           */
          this.elements = {};

          const sources = elements.sources;

          let isDragging = false;
          let isSourceDownEventTarget;
          let mouseDownClientX;
          let mouseDownClientY;
          let differenceX;
          let differenceY;
          let slideAble = true;
          let rememberedX = 0;
          let rememberedY = 0;

          this.clearZoom = function () {
            rememberedX = 0;
            rememberedY = 0;
            differenceY = 0;
            differenceX = 0;
            data.zoom = 1;
            data.zooming = false;
            _this.mouseDownFirst = true;
          };

          this.mouseDownEvent = function (e) {
            // tag can't be video cause it would be unclickable in microsoft browsers
            if (e.target.tagName !== 'VIDEO' && !e.touches) {
              e.preventDefault();
            }

            if (e.target.classList.contains('fslightbox-single-source')) {
              isSourceDownEventTarget = true;
            }

            differenceX = 0;
            differenceY = 0;
            isDragging = true;

            if (!data.zooming && data.totalSlides === 1) {
              return;
            }

            if (e.touches) {
              mouseDownClientX = e.touches[0].clientX;
              if (data.zooming) {
                mouseDownClientY = e.touches[0].clientY;
              }
            } else if (e.clientX) {
              mouseDownClientX = e.clientX;
              mouseDownClientY = e.clientY;
            }
          };

          this.mouseUpEvent = function () {
            if (!isDragging) {
              return;
            }
            isDragging = false;

            if (self.element.contains(_this.invisibleHover)) {
              self.element.removeChild(_this.invisibleHover);
            }

            if (self.element.classList.contains(CURSOR_GRABBING_CLASS_NAME)) {
              self.element.classList.remove(CURSOR_GRABBING_CLASS_NAME);
            }

            if (differenceX === 0) {
              if (!isSourceDownEventTarget) {
                self.close();
              }
              isSourceDownEventTarget = false;
              return;
            }
            isSourceDownEventTarget = false;

            if (data.zooming) {
              rememberedX = differenceX;
              rememberedY = differenceY;
            }

            // don't slide if user didn't move mouse or user is zooming or previous animation is working (slideAble = false)
            if (
              differenceX === 0 ||
              typeof differenceX === 'undefined' ||
              data.zooming ||
              !slideAble
            ) {
              return;
            }

            slideAble = false;
            let sourcesIndexes = self.getSourcesIndexes.all(data.slide);

            // add transition if user slide to source
            for (let i in sourcesIndexes) {
              sources[sourcesIndexes[i]].style.transition =
                'transform ' + data.slideAnimationDuration + 'ms';
            }
            const previousSlide = data.slide;

            // slide previous
            if (differenceX > 0) {
              self.caption.switchCaptions('previous');

              // update slide number
              if (previousSlide === 1) {
                self.othersMethods.updateSlideNumber(data.totalSlides);
              } else {
                self.othersMethods.updateSlideNumber(previousSlide - 1);
              }

              if (data.urls.length >= 2) {
                self.transforms.transformPlus(sources[sourcesIndexes.current]);
                self.transforms.transformNull(sources[sourcesIndexes.previous]);
              } else {
                self.transforms.transformNull(sources[sourcesIndexes.current]);
              }
              // get new index
              let previousSourceIndex = self.getSourcesIndexes.previous(
                data.slide
              );

              //if source isn't already in memory
              if (typeof sources[previousSourceIndex] === 'undefined') {
                self.createSources('previous');
              }
            }

            // slide next
            else if (differenceX < 0) {
              self.caption.switchCaptions('next');

              //update slide number
              if (data.slide === data.totalSlides) {
                self.othersMethods.updateSlideNumber(1);
              } else {
                self.othersMethods.updateSlideNumber(data.slide + 1);
              }

              if (data.urls.length > 1) {
                self.transforms.transformMinus(sources[sourcesIndexes.current]);
                self.transforms.transformNull(sources[sourcesIndexes.next]);
                // show / close captions if exist
              } else {
                self.transforms.transformNull(sources[sourcesIndexes.current]);
              }

              // get new index
              let nextSourceIndex = self.getSourcesIndexes.next(data.slide);

              //if source isn't already in memory
              if (typeof sources[nextSourceIndex] === 'undefined') {
                self.createSources('next');
              }
            }

            differenceX = 0;
            if (data.thumbnails) {
              self.thumbnails.thumbnailsLogic.switchThumbnailOnSlideChange(
                previousSlide,
                data.slide
              );
            }
            // method that is called after every slide change
            self.afterSlideChange();

            setTimeout(function () {
              // remove transition because with dragging it looks awful
              for (let i in sourcesIndexes) {
                sources[sourcesIndexes[i]].style.transition = '';
              }

              _this.clearZoom();

              // user shouldn't be able to slide when animation is running
              slideAble = true;
            }, data.slideAnimationDuration);
          };

          this.mouseMoveEvent = function (e) {
            if (!isDragging || !slideAble) {
              return;
            }

            let clientX;
            e.touches
              ? (clientX = e.touches[0].clientX)
              : (clientX = e.clientX);

            if (!self.element.contains(_this.invisibleHover)) {
              self.element.appendChild(_this.invisibleHover);
            }
            differenceX = clientX - mouseDownClientX;

            if (!data.zooming) {
              // if user swiped but there is only one slide we dont want further code to execute but we want to prevent lightbox
              // from closing so we set difference to 1
              if (differenceX !== 0 && self.data.totalSlides === 1) {
                differenceX = 1;
                return;
              }

              ifMainNotContainsCursorGrabbingClassListAddIt();

              const urlsLength = data.urls.length;
              const sourcesIndexes = self.getSourcesIndexes.all(data.slide);
              if (urlsLength >= 3) {
                sources[sourcesIndexes.previous].style.transform =
                  'translate(' +
                  (-data.slideDistance * window.innerWidth + differenceX) +
                  'px,0)';
              }

              if (urlsLength >= 1) {
                sources[sourcesIndexes.current].style.transform =
                  'translate(' + differenceX + 'px,0)';
              }

              if (urlsLength >= 2) {
                sources[sourcesIndexes.next].style.transform =
                  'translate(' +
                  (data.slideDistance * window.innerWidth + differenceX) +
                  'px,0)';
              }
            }

            // user is zooming changing slides don't work
            else {
              ifMainNotContainsCursorGrabbingClassListAddIt();

              let clientY;
              e.touches
                ? (clientY = e.touches[0].clientY)
                : (clientY = e.clientY);
              differenceY = clientY - mouseDownClientY;
              if (rememberedY) {
                differenceY = rememberedY + differenceY;
              }
              if (rememberedX) {
                differenceX = rememberedX + differenceX;
              }
              sources[data.slide - 1].style.transform =
                'translate(' + differenceX + 'px,' + differenceY + 'px)';
            }
          };

          const ifMainNotContainsCursorGrabbingClassListAddIt = function () {
            if (!self.element.classList.contains(CURSOR_GRABBING_CLASS_NAME)) {
              self.element.classList.add(CURSOR_GRABBING_CLASS_NAME);
            }
          };

          this.init = function () {
            data.turnOnListenersSlides = true;
          };
        };
      },
      { './utils/DOMObject': 25 }
    ],
    7: [
      function (require, module, exports) {
        module.exports = function (self) {
          const DOMObject = require('../utils/DOMObject');
          const captionsContainer = new DOMObject('div').addClassesAndCreate([
            'fslightbox-captions-container'
          ]);
          const elements = self.elements;
          const data = self.data;

          this.createCaption = function (
            title,
            description,
            categories,
            sourceIndex
          ) {
            if (!title && !description && !categories) return;

            const captionWrapper = new DOMObject('div').addClassesAndCreate([
              'fslightbox-caption-wrapper'
            ]);
            const captionBody = new DOMObject('div').addClassesAndCreate([
              'fslightbox-caption-body'
            ]);

            if (title) {
              const captionTitle = new DOMObject('div').addClassesAndCreate([
                'fslightbox-caption-title'
              ]);
              captionTitle.innerHTML = title;
              captionBody.appendChild(captionTitle);
            }

            if (description) {
              const captionTitle = new DOMObject('div').addClassesAndCreate([
                'fslightbox-caption-description'
              ]);
              captionTitle.innerHTML = description;
              captionBody.appendChild(captionTitle);
            }

            if (categories) {
              const captionCategories = new DOMObject(
                'div'
              ).addClassesAndCreate(['fslightbox-caption-categories']);
              captionCategories.innerHTML = categories;
              captionBody.appendChild(captionCategories);
            }

            captionWrapper.appendChild(captionBody);
            elements.captions[sourceIndex] = captionWrapper;
            captionsContainer.appendChild(captionWrapper);
          };

          this.appendCaptionContainer = function () {
            self.element.appendChild(captionsContainer);
          };

          /**
           * We will close it using opacity but with z-index 0 too to make link etc in others captions clickable
           * @param elem
           */
          this.hideCaption = function (elem) {
            if (elem && elem.style) {
              elem.style.opacity = '0';
              elem.style.zIndex = '0';
            }
          };

          /**
           * We will show it using opacity 0 but we will add z-index 13 too make link clickable (it will be over mouse down event targets)
           * @param elem
           */
          const showCaption = function (elem) {
            if (elem && elem.style) {
              elem.style.opacity = '1';
              elem.style.zIndex = '13';
            }
          };

          this.switchCaptions = function (type) {
            const captions = elements.captions;
            const sourcesIndexes = self.getSourcesIndexes.all(self.data.slide);
            let areThumbnailsOpen;
            if (self.data.thumbnails) {
              areThumbnailsOpen = self.thumbnails.thumbnailsOpen;
            }

            switch (type) {
              case 'next':
                if (captions[sourcesIndexes.current]) {
                  this.hideCaption(captions[sourcesIndexes.current]);
                }

                if (self.data.thumbnails) {
                  if (captions[sourcesIndexes.next] && !areThumbnailsOpen) {
                    showCaption(captions[sourcesIndexes.next]);
                  }
                } else {
                  if (captions[sourcesIndexes.next]) {
                    showCaption(captions[sourcesIndexes.next]);
                  }
                }

                break;
              case 'previous':
                if (captions[sourcesIndexes.current]) {
                  this.hideCaption(captions[sourcesIndexes.current]);
                }

                if (self.data.thumbnails) {
                  if (captions[sourcesIndexes.previous] && !areThumbnailsOpen) {
                    showCaption(captions[sourcesIndexes.previous]);
                  }
                } else {
                  if (captions[sourcesIndexes.previous]) {
                    showCaption(captions[sourcesIndexes.previous]);
                  }
                }
                break;
              case 'current':
                captions.forEach(function (caption) {
                  this.hideCaption(caption);
                });
                if (self.data.thumbnails) {
                  if (captions[sourcesIndexes.current] && !areThumbnailsOpen) {
                    showCaption(captions[sourcesIndexes.current]);
                  }
                } else {
                  if (captions[sourcesIndexes.current]) {
                    showCaption(captions[sourcesIndexes.current]);
                  }
                }
            }
          };

          let wordsHighlighted = false;

          this.upListener = function () {
            window.getSelection().toString()
              ? (wordsHighlighted = true)
              : (wordsHighlighted = false);
          };

          this.clearHighlight = function () {
            if (wordsHighlighted) {
              window.getSelection().empty();
            }
          };

          this.detectCaptionsHeights = function () {
            const captions = elements.captions;
            for (let captionIndex in captions) {
              data.captionsHeights[captionIndex] =
                captions[captionIndex].offsetHeight;
            }
          };

          this.showCurrentCaption = function () {
            if (elements.captions[self.data.slide - 1]) {
              showCaption(elements.captions[self.data.slide - 1]);
            }
          };

          this.hideAllCaptions = function () {
            for (let i = 0; i < elements.captions.length; i++) {
              if (elements.captions[i]) {
                this.hideCaption(elements.captions[i]);
              }
            }
          };
        };
      },
      { '../utils/DOMObject': 25 }
    ],
    8: [
      function (require, module, exports) {
        module.exports = function (self) {
          /**
       * @description
       Contains [indexes]:
       - nav [0]
       - slide buttons [1,2]
       - thumbnail wrapper [3]
       - thumbnail default button [4]
       * @type {Array}
       */
          let elementStyles = [];
          let currentTimeout = {};

          /**
           * @constructor
           */
          function hideTimeout() {
            this.timeout = setTimeout(function () {
              hideUI();
            }, self.data.timeToHideUI);
          }

          let restartHiding = function () {
            clearTimeout(currentTimeout.timeout);
            currentTimeout = new hideTimeout();
          };

          let loopOverStyles = function (styleName, value) {
            for (let i = 0; i < elementStyles.length; i++) {
              elementStyles[i][styleName] = value;
            }
          };

          let hideUI = function () {
            self.data.isUIHidden = true;
            loopOverStyles('opacity', '0');
          };
          let showUI = function () {
            self.data.isUIHidden = false;
            loopOverStyles('opacity', '1');
          };

          this.userMoved = function () {
            self.data.isUIHidden ? showUI() : restartHiding();
          };

          this.init = function () {
            // push styles of elements that we will be hiding
            elementStyles[0] = self.elements.nav.style;
            if (self.data.totalSlides > 1) {
              elementStyles.push(self.elements.slideButtons.left.style);
              elementStyles.push(self.elements.slideButtons.right.style);
            }
            if (self.data.thumbnails) {
              elementStyles.push(self.thumbnails.thumbnailWrapper.style);

              if (
                self.data.showDefaultThumbnailButton &&
                self.data.totalSlides > 1
              ) {
                elementStyles.push(self.thumbnails.thumbnailShowButton.style);
              }
            }

            // add opacity
            loopOverStyles('transition', 'opacity .3s');
            currentTimeout = new hideTimeout();
          };
        };
      },
      {}
    ],
    9: [
      function (require, module, exports) {
        module.exports = function (self) {
          const data = self.data;
          const slideShowButtonData = self.data.svg.toolbarButtons.slideshow;
          const elements = self.elements;
          let slideshowInstance = {};
          let isSlideShowWorking = false;
          let firstTime = true;
          let bar = new (require('../utils/DOMObject'))(
            'div'
          ).addClassesAndCreate(['fslightbox-slide-show-bar']);
          let svg;
          let path;
          let incrementValue;
          let animationFrame;
          let width = 0;

          const changeSlide = function () {
            cancelAnimationFrame(animationFrame);
            width = 0;
            let slide = data.slide;
            self.caption.hideCaption(elements.captions[slide - 1]);
            self.changeSlideByDragging.clearZoom();
            if (slide !== data.totalSlides) {
              self.setSlide(slide + 1, true);
            } else {
              self.setSlide(1, true);
            }
          };

          const animateSlideShowBar = function () {
            width += incrementValue;
            bar.style.width = width + 'px';
            if (width >= window.innerWidth) {
              changeSlide();
              return;
            }
            if (isSlideShowWorking) {
              animationFrame = requestAnimationFrame(animateSlideShowBar);
            }
          };

          function SlideShow() {
            animateSlideShowBar();
          }

          const setSvgToStart = function () {
            path.setAttributeNS(null, 'd', slideShowButtonData.startD);
            svg.setAttributeNS(
              null,
              'viewBox',
              slideShowButtonData.startViewBox
            );
            svg.setAttributeNS(null, 'width', slideShowButtonData.startWidth);
            svg.setAttributeNS(null, 'height', slideShowButtonData.startHeight);
          };

          const setSvgToPause = function () {
            path.setAttributeNS(null, 'd', slideShowButtonData.pauseD);
            svg.setAttributeNS(
              null,
              'viewBox',
              slideShowButtonData.pauseViewBox
            );
            svg.setAttributeNS(null, 'width', slideShowButtonData.pauseWidth);
            svg.setAttributeNS(null, 'height', slideShowButtonData.pauseHeight);
          };

          this.resetIncrementValue = function () {
            incrementValue = (window.innerWidth / data.slideShowTimeout) * 16.5;
          };

          const startSlideShow = function () {
            isSlideShowWorking = true;
            cancelAnimationFrame(animationFrame);
            setSvgToPause();
            bar.style.opacity = '1';
            data.resetSlideShowOnSetSlide = true;
            slideshowInstance = new SlideShow();
          };

          const stopSlideShow = function () {
            setSvgToStart();
            bar.style.opacity = '0';
            cancelAnimationFrame(animationFrame);
            data.resetSlideShowOnSetSlide = false;
            isSlideShowWorking = false;
          };

          const getButtonAndCalculateTimeout = function () {
            svg = self.elements.toolbarButtons['slideshow'].firstChild;
            path = svg.firstChild;
            bar.style.background = data.slideShowBarColor;
            self.element.appendChild(bar);
            incrementValue = (window.innerWidth / data.slideShowTimeout) * 16.5;
            firstTime = false;
          };

          this.getIsSlideShowWorking = function () {
            return isSlideShowWorking;
          };

          this.resetSlideShow = function () {
            stopSlideShow();
            startSlideShow();
          };

          this.slideshow = function () {
            if (firstTime) getButtonAndCalculateTimeout();
            isSlideShowWorking ? stopSlideShow() : startSlideShow();
          };
        };
      },
      { '../utils/DOMObject': 25 }
    ],
    10: [
      function (require, module, exports) {
        module.exports = function (SVGIcon, self) {
          const data = self.data;
          const elements = self.elements;

          this.thumbnailsBody = {};
          this.thumbnailWrapper = {};
          this.thumbnailsDOMAppended = false;
          this.thumbnailsOpen = false;
          this.thumbnailsElements = [];

          this.isThumbnailsElementsAppended = false;
          this.thumbnailsBlobs = [];
          this.thumbnailShowButton = {};

          this.ytAndVideosForWhichLoadSigns = [];
          this.thumbnailsBodyWidth = 0;
          this.thumbnailsWidths = [];
          this.thumbnailsWasSlided = false;
          this.thumbnailWrapperFadingOut = false;
          this.areThumbnailsFadedOut = false;

          const DOMObject = require('../utils/DOMObject');

          const loader = new DOMObject('div').addClassesAndCreate([
            'fslightbox-loader',
            'fslightbox-thumbnails-loader'
          ]);
          const _this = this;

          /**
           * Thumbnails carousel and changing slides via thumbnails
           * @type {module.exports}
           */
          this.thumbnailsLogic = new (require('./thumbnailsLogic'))(
            _this,
            data
          );

          /**
           * Renders thumbnails button
           */
          const createThumbnailButton = function () {
            _this.thumbnailShowButton = new DOMObject(
              'div'
            ).addClassesAndCreate(['fslightbox-thumbnails-button']);
            _this.thumbnailShowButton.appendChild(
              new SVGIcon(
                '0 0 30 30',
                '1.5em',
                '1.5em',
                'M 5 12 C 3.343 12 2 13.343 2 15 C 2 16.657 3.343 18 5 18 C 6.657 18 8 16.657 8 15 C 8 13.343 6.657 12 5 12 z M 15 12 C 13.343 12 12 13.343 12 15 C 12 16.657 13.343 18 15 18 C 16.657 18 18 16.657 18 15 C 18 13.343 16.657 12 15 12 z M 25 12 C 23.343 12 22 13.343 22 15 C 22 16.657 23.343 18 25 18 C 26.657 18 28 16.657 28 15 C 28 13.343 26.657 12 25 12 z'
              )
            );
            _this.thumbnailShowButton.title = 'Thumbnails';
            _this.thumbnailShowButton.onclick = _this.hideShowThumbnails;

            self.element.appendChild(_this.thumbnailShowButton);
          };

          /**
           * Method called after clicking in both toolbar thumbnails button and normal bottom right thumbnails button
           */
          this.hideShowThumbnails = function () {
            // to prevent situation in which both captions and thumbnails are hidden due to fadingOut with setTimeout
            if (_this.thumbnailWrapperFadingOut || data.zooming) return;

            if (!_this.thumbnailsDOMAppended) {
              _this.appendThumbnailsDOM();
              _this.createThumbnailsElements();
              _this.showThumbnails();
              return;
            }

            if (_this.thumbnailsOpen) {
              self.caption.showCurrentCaption();
              _this.hideThumbnailsSetSourcesDimensions();
            } else {
              self.caption.hideAllCaptions();
              _this.showThumbnailsSetSourcesDimensions();
            }
          };

          /**
           * Thumbnails loader is used only whe
           */
          this.appendThumbnailsLoader = function () {
            loader.innerHTML = '<div></div><div></div><div></div><div></div>';
            this.thumbnailWrapper.appendChild(loader);
          };

          /**
           * Creates and append Thumbnails DOM tree
           */
          this.createThumbnailsDOM = function () {
            this.thumbnailWrapper = new DOMObject('div').addClassesAndCreate([
              'fslightbox-thumbnails-wrapper'
            ]);
            this.thumbnailsBody = new DOMObject('div').addClassesAndCreate([
              'fslightbox-thumbnails-body'
            ]);
            this.thumbnailWrapper.appendChild(this.thumbnailsBody);
            data.turnOnListenersThumbnails = true;
          };

          this.appendThumbnailsDOM = function () {
            self.element.appendChild(this.thumbnailWrapper);
            this.appendThumbnailsLoader();
            this.thumbnailsDOMAppended = true;
          };

          /**
           * create thumbnails from urls of box
           */
          this.createThumbnailsElements = function () {
            for (let urlIndex = 0; urlIndex < data.urls.length; urlIndex++) {
              this.createSingleThumbnail(urlIndex);
            }
          };

          this.createSingleThumbnail = function (urlIndex) {
            if (data.urlsTypes[urlIndex] === 'image') {
              createImageThumbnail(urlIndex, _this.thumbnailsBlobs[urlIndex]);
            } else {
              createNotImageThumbnail(urlIndex);
            }
          };

          const createNotImageThumbnail = function (urlIndex) {
            _this.ytAndVideosForWhichLoadSigns.push(urlIndex);

            if (data.thumbnailsUrls[urlIndex]) {
              createImageThumbnail(urlIndex, data.thumbnailsUrls[urlIndex]);
            } else if (data.videosPosters[urlIndex]) {
              createImageThumbnail(urlIndex, data.videosPosters[urlIndex]);
            } else if (data.urlsTypes[urlIndex] === 'youtube') {
              createImageThumbnail(
                urlIndex,
                'https://img.youtube.com/vi/' +
                  data.youtubeIDs[urlIndex] +
                  '/0.jpg'
              );
            } else {
              _this.createThumbnailForYoutubeAndVideosIfNoPoster(urlIndex);
            }
          };

          /**
           * Method that create create image thumbnail
           * Used both for videos and images
           * @param urlIndex
           * @param url
           */
          const createImageThumbnail = function (urlIndex, url) {
            const img = new DOMObject('img').addClassesAndCreate([
              'fslightbox-thumbnail'
            ]);
            img.addEventListener('contextmenu', (e) => {
              if (self.data.imageCopyProtection) e.preventDefault();
            });
            img.setAttribute('alt', self.data.altAttributes[urlIndex]);
            img.onload = function () {
              onLoadThumbnail(urlIndex, img, this.width, this.height);
            };
            img.src = url;
          };

          /**
           * Creates svg icon for thumbnail if it is video or youtube type
           * @param type
           * @param d
           * @returns {*}
           */
          const createIconForThumbnail = function (type, d, viewBox) {
            if (!viewBox) {
              viewBox = '0 0 30 30';
            }

            const playIcon = new SVGIcon(viewBox, '1.5em', '1.5em', d);
            playIcon.setAttributeNS(
              null,
              'class',
              'fslightbox-video-icon fslightbox-svg-icon'
            );
            return playIcon;
          };

          this.createThumbnailForYoutubeAndVideosIfNoPoster = function (
            urlIndex
          ) {
            onLoadThumbnail(
              urlIndex,
              new DOMObject('div').addClassesAndCreate([
                'fslightbox-thumbnail',
                'fslightbox-youtube-thumbnail'
              ]),
              640,
              380
            );
          };

          const onLoadThumbnail = function (
            urlIndex,
            thumbnail,
            width,
            height
          ) {
            data.thumbnailsAndPostersDimensions[urlIndex] = {
              width: width,
              height: height
            };

            scaleThumbnail(urlIndex, thumbnail);
            _this.thumbnailsElements[urlIndex] = thumbnail;

            // append thumbnails when all are loaded
            let thumbnailsCount = 0;
            _this.thumbnailsElements.forEach(function () {
              thumbnailsCount++;
            });
            if (thumbnailsCount === data.urls.length) {
              appendThumbnails();
            }
            _this.thumbnailsElements[urlIndex] = thumbnail;
          };

          const createThumbnailHolder = function () {
            return new DOMObject('div').addClassesAndCreate([
              'fslightbox-thumbnail-holder'
            ]);
          };

          /**
           * IE is a nightmare we need to scale thumbnails manually
           * @param urlIndex
           * @param thumbnail
           */
          const scaleThumbnail = function (urlIndex, thumbnail) {
            const defaultDimensions =
              data.thumbnailsAndPostersDimensions[urlIndex];
            const coefficient =
              defaultDimensions.width / defaultDimensions.height;
            const thumbnailsBodyHeight = _this.thumbnailsBody.offsetHeight;
            thumbnail.style.height = thumbnailsBodyHeight - 4 + 'px';
            thumbnail.style.width = thumbnailsBodyHeight * coefficient + 'px';
          };

          /**
           * If all thumbnail are loaded append them
           */
          const appendThumbnails = function () {
            // clear loader
            _this.thumbnailWrapper.removeChild(loader);
            _this.thumbnailsBody.style.opacity = '1';
            const thumbnails = _this.thumbnailsElements;
            self.othersMethods.addDimensionSourceTransition(elements.sources);

            setTimeout(function () {
              self.othersMethods.removeDimensionSourceTransition(
                elements.sources
              );
            }, 300);

            thumbnails.forEach(function (thumbnail, i) {
              appendThumbnail(thumbnail, i);

              // On thumbnail click we will change slide and update thumbnail highlight
              // but only if user didn't slide
              thumbnail.onclick = function () {
                onClickThumbnail(i);
              };
            });

            _this.isThumbnailsElementsAppended = true;
            // we are setting dimensions only if user did not select them to load on start because if this would be enabled
            // we would setSourcesDimensions twice once here once at loadsources
            if (!data.showThumbnailsOnInit) {
              self.onResizeEvent.setSourcesDimensions();
            }
            _this.thumbnailsLogic.setThumbnailsTransforms();
          };

          /**
           * @description On thumbnail click we will change slide and update thumbnail highlight but only if user didn't slide
           * @param urlIndex
           */
          const onClickThumbnail = function (urlIndex) {
            if (_this.thumbnailsWasSlided || urlIndex === data.slide - 1)
              return;
            self.caption.hideAllCaptions();
            _this.thumbnailsLogic.switchThumbnailOnSlideChange(
              data.slide,
              urlIndex + 1
            );
            self.setSlide(urlIndex + 1);
          };

          const appendThumbnail = function (thumbnail, urlIndex) {
            const thumbnailHolder = createThumbnailHolder();
            thumbnailHolder.style.marginRight =
              0.5 * data.thumbnailsDistance + 'px';
            thumbnailHolder.style.marginLeft =
              0.5 * data.thumbnailsDistance + 'px';

            // create hover holder to be able to use hover effects on thumbnails
            const thumbnailHoverHolder = new DOMObject(
              'div'
            ).addClassesAndCreate(['fslightbox-thumbnail-hover-holder']);
            thumbnailHolder.appendChild(thumbnailHoverHolder);

            // detect width of thumbnail depending on thumbnails width and distance between them
            // add it to array and increment thumbnailsBodyWidth
            const thumbnailWidth =
              parseInt(thumbnail.style.width) + data.thumbnailsDistance + 4;
            _this.thumbnailsWidths.push(thumbnailWidth);
            _this.thumbnailsBodyWidth += thumbnailWidth;

            if (_this.ytAndVideosForWhichLoadSigns.indexOf(urlIndex) >= 0) {
              const type = data.urlsTypes[urlIndex];
              let icon;
              if (type === 'video') {
                icon = createIconForThumbnail(
                  type,
                  'M 16 3 C 13.791 3 12 4.791 12 7 C 12 9.209 13.791 11 16 11 C 18.209 11 20 9.209 20 7 C 20 4.791 18.209 3 16 3 z M 6 5 C 4.343 5 3 6.343 3 8 C 3 9.657 4.343 11 6 11 C 7.657 11 9 9.657 9 8 C 9 6.343 7.657 5 6 5 z M 4 13 C 2.895 13 2 13.895 2 15 L 2 25 C 2 26.105 2.895 27 4 27 L 18 27 C 19.105 27 20 26.105 20 25 L 20 15 C 20 13.895 19.105 13 18 13 L 4 13 z M 27 14 A 1 1 0 0 0 26.443359 14.169922 L 22 17 L 22 20 L 22 23 L 26.429688 25.822266 A 1 1 0 0 0 26.478516 25.851562 A 1 1 0 0 0 27 26 A 1 1 0 0 0 28 25 L 28 20 L 28 15 A 1 1 0 0 0 27 14 z'
                );
              } else if (type === 'invalid') {
                icon = createIconForThumbnail(
                  type,
                  'M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16.212,8l-0.2,9h-2.024l-0.2-9 H16.212z M15.003,22.189c-0.828,0-1.323-0.441-1.323-1.182c0-0.755,0.494-1.196,1.323-1.196c0.822,0,1.316,0.441,1.316,1.196 C16.319,21.748,15.825,22.189,15.003,22.189z'
                );
              } else if (type === 'youtube') {
                icon = createIconForThumbnail(
                  type,
                  'M 15 4 C 10.814 4 5.3808594 5.0488281 5.3808594 5.0488281 L 5.3671875 5.0644531 C 3.4606632 5.3693645 2 7.0076245 2 9 L 2 15 L 2 15.001953 L 2 21 L 2 21.001953 A 4 4 0 0 0 5.3769531 24.945312 L 5.3808594 24.951172 C 5.3808594 24.951172 10.814 26.001953 15 26.001953 C 19.186 26.001953 24.619141 24.951172 24.619141 24.951172 L 24.621094 24.949219 A 4 4 0 0 0 28 21.001953 L 28 21 L 28 15.001953 L 28 15 L 28 9 A 4 4 0 0 0 24.623047 5.0546875 L 24.619141 5.0488281 C 24.619141 5.0488281 19.186 4 15 4 z M 12 10.398438 L 20 15 L 12 19.601562 L 12 10.398438 z'
                );
              } else if (type === 'vimeo') {
                icon = createIconForThumbnail(
                  type,
                  'M367.243,28.754c-59.795-1.951-100.259,31.591-121.447,100.664c10.912-4.494,21.516-6.762,31.858-6.762   c21.804,0,31.455,12.237,28.879,36.776c-1.278,14.86-10.911,36.482-28.879,64.858c-18.039,28.423-31.513,42.61-40.464,42.61   c-11.621,0-22.199-21.958-31.857-65.82c-3.239-12.918-9.031-45.812-17.324-98.765c-7.775-49.046-28.32-71.962-61.727-68.741   C112.15,34.873,90.98,47.815,62.726,72.308C42.113,91.032,21.228,109.761,0,128.471l20.225,26.112   c19.303-13.562,30.595-20.311,33.731-20.311c14.802,0,28.625,23.219,41.488,69.651c11.53,42.644,23.158,85.23,34.744,127.812   c17.256,46.466,38.529,69.708,63.552,69.708c40.473,0,90.028-38.065,148.469-114.223c56.537-72.909,85.725-130.352,87.694-172.341   C432.498,58.764,411.613,30.028,367.243,28.754z',
                  '0 0 430.118 430.118'
                );
              }

              if (thumbnail.tagName !== 'DIV' && thumbnail.tagName !== 'DIV') {
                thumbnailHolder.classList.add(
                  'fslightbox-thumbnail-video-darken'
                );
              }

              // icon needs onclick that changes slides too
              // icon.onclick = function () {
              //   onClickThumbnail(urlIndex);
              // };
              // thumbnailHoverHolder.appendChild(icon);
            }
            thumbnailHoverHolder.appendChild(thumbnail);
            if (urlIndex === data.slide - 1) {
              _this.thumbnailsLogic.addActiveThumbnailBorder(
                thumbnailHoverHolder.firstChild
              );
            }
            _this.thumbnailsBody.appendChild(thumbnailHolder);
          };

          this.thumbnailChangeState = function () {
            elements.sources[data.slide - 1].style.transition = 'height .3s';
            self.othersMethods.addDimensionSourceTransition(elements.sources);
            setTimeout(function () {
              self.othersMethods.removeDimensionSourceTransition(
                elements.sources
              );
            }, 300);
          };

          this.showThumbnails = function () {
            this.thumbnailsOpen = true;
            self.caption.hideAllCaptions();
            this.thumbnailChangeState();
            this.thumbnailWrapper.style.opacity = '1';
            if (!self.element.contains(this.thumbnailWrapper)) {
              self.element.appendChild(this.thumbnailWrapper);
            }
          };
          /**
           * Show create thumbnails
           */
          this.showThumbnailsSetSourcesDimensions = function () {
            this.showThumbnails();
            // We are changing sources dimensions only after thumbnails are appended because
            // if thumbnails are appended for first time setSourcesDimensions() is called in appendThumbnails()
            // method for better UX, isThumbnailsElementsAppended is switched in appendThumbnails() too
            if (this.isThumbnailsElementsAppended) {
              self.onResizeEvent.setSourcesDimensions();
            }
          };

          this.hideThumbnails = function () {
            this.thumbnailsOpen = false;
            this.thumbnailChangeState();
            this.thumbnailWrapper.style.opacity = '0';
            this.thumbnailWrapperFadingOut = true;
            setTimeout(function () {
              _this.thumbnailWrapperFadingOut = false;
              self.element.removeChild(_this.thumbnailWrapper);
            }, 300);
          };

          this.fadeOutThumbnails = function () {
            this.areThumbnailsFadedOut = true;
            this.thumbnailWrapper.style.opacity = '0';
          };

          this.fadeInThumbnails = function () {
            this.areThumbnailsFadedOut = false;
            this.thumbnailWrapper.style.opacity = '1';
          };

          /**
           * Hides created thumbnails
           */
          this.hideThumbnailsSetSourcesDimensions = function () {
            this.hideThumbnails();
            self.onResizeEvent.setSourcesDimensions();
          };

          this.initThumbnails = function () {
            if (data.showDefaultThumbnailButton) {
              createThumbnailButton();
            }

            this.createThumbnailsDOM();

            if (data.showThumbnailsOnInit) {
              this.thumbnailsOpen = true;
              this.appendThumbnailsDOM();
            }
          };
        };
      },
      {
        '../utils/DOMObject': 25,
        './thumbnailsLogic': 11
      }
    ],
    11: [
      function (require, module, exports) {
        module.exports = function (_this, data) {
          this.isUsingIETransforms = false;
          this.firstTimeDetectIfUsingIETransforms = false;
          const __this = this;

          this.addActiveThumbnailBorder = function (elem) {
            const parent = elem.parentNode;
            parent.style.borderWidth = '2px';
            parent.style.borderStyle = 'solid';
            parent.style.borderColor = data.thumbnailHighlightColor;
            parent.style.boxShadow = '0 2px 2px' + data.thumbnailHighlightColor;
          };

          this.switchThumbnailOnSlideChange = function (
            previousSlide,
            currentSlide
          ) {
            const thumbnails = _this.thumbnailsElements;
            if (thumbnails.length === 0) return;
            thumbnails[previousSlide - 1].parentNode.style.border = '';
            thumbnails[previousSlide - 1].parentNode.style.boxShadow = '';
            this.addActiveThumbnailBorder(thumbnails[currentSlide - 1]);
          };

          /**
           * Transforms all thumbnails by given value
           * @param howMuch
           * @param transform
           */
          this.transformThumbnailsBy = function (howMuch, transform) {
            const thumbnailsElements = _this.thumbnailsElements;
            for (let i = 0; i < thumbnailsElements.length; i++) {
              if (transform) {
                thumbnailsElements[i].parentNode.parentNode.style.transition =
                  '.3s transform';
              }
              _this.thumbnailsTransform = howMuch;
              thumbnailsElements[i].parentNode.parentNode.style.transform =
                'translateX(' + howMuch + 'px)';
            }
          };

          this.transformThumbnailsByWithTransform = function (howMuch) {
            this.transformThumbnailsBy(howMuch, true);
          };

          this.transformThumbnailsByWithoutTransform = function (howMuch) {
            this.transformThumbnailsBy(howMuch, false);
          };

          this.setThumbnailsTransforms = function () {
            const thumbnailsWidth = _this.thumbnailsBodyWidth;
            const deviceWidth = window.innerWidth;
            _this.thumbnailsBody.style.width = window.innerWidth + 'px';

            let currentSlideXPlusWidth = 0;
            let toScroll = 0;
            for (let i = 0; i <= data.slide; i++) {
              if (!_this.thumbnailsWidths[i]) continue;
              if (i < data.slide) {
                currentSlideXPlusWidth += _this.thumbnailsWidths[i];
              }
              toScroll += _this.thumbnailsWidths[i];
            }

            /** DETECT IF SHOULD RUN IE CASES IE CASES **/
            // If content goes out in normal browsers it get's out from both sides
            // In IE it goes only out from right side left side is staying at left = 0
            // We check this case only ones
            if (
              thumbnailsWidth > deviceWidth &&
              !this.firstTimeDetectIfUsingIETransforms
            ) {
              this.firstTimeDetectIfUsingIETransforms = true;
              if (
                _this.thumbnailsElements[0].parentNode.parentNode.getBoundingClientRect()
                  .left >= 5
              ) {
                this.isUsingIETransforms = true;
              }
            }
            /*************/

            if (currentSlideXPlusWidth > deviceWidth) {
              // 2 hours for one line I suck at math really
              this.isUsingIETransforms
                ? this.transformThumbnailsByWithTransform(
                    deviceWidth - toScroll
                  )
                : this.transformThumbnailsByWithTransform(
                    0.5 * (thumbnailsWidth + deviceWidth) - toScroll
                  );
              return;
            }

            if (thumbnailsWidth > deviceWidth && !this.isUsingIETransforms) {
              // if thumbnails are too wide it will be centered
              // so we need to multiply difference between device with and thumbnails width by 0.5
              const differenceBetweenTooWideThumbnails =
                0.5 * (thumbnailsWidth - deviceWidth);
              this.transformThumbnailsByWithTransform(
                differenceBetweenTooWideThumbnails
              );
            }
            // if thumbnails width is wider that device width we need to reset transforms
            else {
              this.transformThumbnailsByWithoutTransform(0);
            }
          };

          /*****************************/
          /** EVENTS **/
          /****************************/

          let moveAble = false;
          let mouseDownX = 0;
          let difference;

          this.downListener = function (e) {
            if (!e.touches) {
              e.preventDefault();
              mouseDownX = e.clientX;
            } else {
              mouseDownX = e.touches[0].clientX;
            }
            moveAble = true;
            _this.thumbnailsWasSlided = false;
            difference = 0;
          };

          this.moveListener = function (e) {
            if (!moveAble) return;
            if (e.touches) {
              difference =
                _this.thumbnailsTransform - (mouseDownX - e.touches[0].clientX);
            } else {
              difference = _this.thumbnailsTransform - (mouseDownX - e.clientX);
            }
            for (let i = 0; i < _this.thumbnailsElements.length; i++) {
              const thumbnailHolderStyle =
                _this.thumbnailsElements[i].parentNode.parentNode.style;
              thumbnailHolderStyle.transition = '';
              thumbnailHolderStyle.transform =
                'translateX(' + difference + 'px)';
            }
          };

          this.upListener = function (e) {
            moveAble = false;
            // Check if user slided if he doesn't we will switch thumbnailsWasSlided to true so changing slide on click method will trigger
            let clientX = 0;
            if (e.clientX) {
              e.preventDefault();
              clientX = e.clientX;
            }
            // when mobile getting clientX throws strange errors for some reason
            else if (e.touches && e.touches[0]) {
              clientX = e.touches[0].clientX;
            }
            if (mouseDownX !== clientX) {
              _this.thumbnailsWasSlided = true;
            }

            if (_this.thumbnailsBodyWidth < window.innerWidth) {
              __this.transformThumbnailsByWithTransform(0);
            }

            // if thumbnails fit in window user shouldn't be able to slide
            if (_this.thumbnailsBodyWidth < window.innerWidth || !difference) {
              return;
            }

            // Normal browsers cases
            if (!__this.isUsingIETransforms) {
              // if user slide too much left we will swish thumbnails to be at x = 0
              if (
                difference >
                (_this.thumbnailsBodyWidth - window.innerWidth) * 0.5
              ) {
                __this.transformThumbnailsByWithTransform(
                  (_this.thumbnailsBodyWidth - window.innerWidth) * 0.5
                );
                return;
              }
              // if user slide too much right we will swish thumbnails to be at end of thumbnails body
              if (
                difference <
                (window.innerWidth - _this.thumbnailsBodyWidth) * 0.5
              ) {
                __this.transformThumbnailsByWithTransform(
                  (window.innerWidth - _this.thumbnailsBodyWidth) * 0.5
                );
                return;
              }
            }
            // Internet Explorer cases
            else {
              // if user slide too much left we will swish thumbnails to be at x = 0
              if (difference > 0) {
                __this.transformThumbnailsByWithTransform(0);
                return;
              }
              // if user slide too much right we will swish thumbnails to be at end of thumbnails body
              if (difference < window.innerWidth - _this.thumbnailsBodyWidth) {
                __this.transformThumbnailsByWithTransform(
                  window.innerWidth - _this.thumbnailsBodyWidth
                );
                return;
              }
            }
            __this.transformThumbnailsByWithTransform(difference);
          };
        };
      },
      {}
    ],
    12: [
      function (require, module, exports) {
        module.exports = function (self, typeOfLoad) {
          const slide = self.data.slide;
          const sourcesIndexes = self.getSourcesIndexes.all(slide);
          const urls = self.data.urls;

          if (typeOfLoad === 'initial') {
            //append loader when loading initially
            self.appendMethods.renderHolderInitial(slide);

            if (urls.length >= 1) {
              self.loadsources.loadSourceElem(sourcesIndexes.current);
            }

            if (urls.length >= 2) {
              self.loadsources.loadSourceElem(sourcesIndexes.next);
            }

            if (urls.length >= 3) {
              self.loadsources.loadSourceElem(sourcesIndexes.previous);
            }
          } else {
            // append loader when loading a next source
            self.appendMethods.renderHolder(slide, typeOfLoad);

            switch (typeOfLoad) {
              case 'previous':
                self.loadsources.loadSourceElem(sourcesIndexes.previous);
                break;
              case 'current':
                self.loadsources.loadSourceElem(sourcesIndexes.current);
                break;
              case 'next':
                self.loadsources.loadSourceElem(sourcesIndexes.next);
                break;
            }
          }
        };
      },
      {}
    ],
    13: [
      function (require, module, exports) {
        module.exports = function (self) {
          const elements = self.elements;
          const data = self.data;

          this.init = function () {
            data.urls.length ? detectDataGivenManually() : automaticDetection();
          };

          /**
       * If user is creating box manually we don't need to detect data
       Or in second case if user is creating captions manually
       */
          const detectDataGivenManually = function () {
            detectCaptions();
            data.totalSlides = data.urls.length;
            if (elements.captions.length) {
              self.caption.appendCaptionContainer();
            }
          };

          /**
       * Method that detects data from user
       Data retrieved from user <a data-fslightbox></a> tags:
       -  box name
       -  all urls
       -  total slide number
       -  video posters
       -  captions
       -  chosen by client thumbnails urls
       */
          const automaticDetection = function () {
            detectCaptions();
            let gallery = data.name;
            let urls = [];
            const a = fsLightboxHelpers.a;
            for (let i = 0; i < a.length; i++) {
              if (!a[i].hasAttribute('data-fslightbox')) {
                continue;
              }
              if (a[i].getAttribute('data-fslightbox') === gallery) {
                let urlsLength = urls.push(a[i].getAttribute('href'));

                if (a[i].hasAttribute('data-video-poster')) {
                  data.videosPosters[urlsLength - 1] =
                    a[i].getAttribute('data-video-poster');
                }

                const thumbnail = a[i].getAttribute('data-thumbnail');
                if (thumbnail) {
                  data.thumbnailsUrls[urlsLength - 1] = thumbnail;
                }

                self.caption.createCaption(
                  a[i].getAttribute('data-caption-title'),
                  a[i].getAttribute('data-caption-description'),
                  a[i].getAttribute('data-caption-categories'),
                  urlsLength - 1
                );
              }
            }

            if (elements.captions.length) self.caption.appendCaptionContainer();
            data.urls = urls;
            data.totalSlides = urls.length;
          };

          const detectCaptions = function () {
            if (elements.captions.length) {
              for (let i in elements.captions) {
                const caption = elements.captions[i];
                self.caption.createCaption(
                  caption.title,
                  caption.description,
                  caption.categories,
                  i
                );
              }
            }
          };
        };
      },
      {}
    ],
    14: [
      function (require, module, exports) {
        module.exports = function (self) {
          /**
           * Array with urls of gallery
           * @type {Array}
           */
          this.urls = [];
          const _this = this;
          this.blobsCounter = 0;

          /**
           * Init detecting type of each url
           * @param urls
           */
          this.init = function () {
            this.urls = self.data.urls;
            for (let i = 0; i < this.urls.length; i++) {
              this.detectType(i);
            }
          };

          /**
           * Detect type of url
           * @param urlIndex
           */
          this.detectType = function (urlIndex) {
            if (checkIfYoutube(urlIndex)) {
              getYoutubeIdAndSetType(urlIndex);
              return;
            }

            if (checkIfVimeo(urlIndex)) {
              getVimeoIdAndSetType(urlIndex);
              return;
            }

            this.checkWithXhr(urlIndex);
          };

          const checkIfYoutube = function (urlIndex) {
            const parser = document.createElement('a');
            parser.href = self.data.urls[urlIndex];

            return parser.hostname === 'www.youtube.com';
          };

          const checkIfVimeo = function (urlIndex) {
            const parser = document.createElement('a');
            parser.href = self.data.urls[urlIndex];

            return (
              parser.hostname === 'vimeo.com' ||
              parser.hostname === 'player.vimeo.com'
            );
          };

          const getYoutubeIdAndSetType = function (urlIndex) {
            let regExp =
              /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            let match = self.data.urls[urlIndex].match(regExp);

            if (match && match[2].length == 11) {
              self.data.urlsTypes[urlIndex] = 'youtube';
              self.data.youtubeIDs[urlIndex] = match[2];

              if (self.data.thumbnails) {
                self.thumbnails.thumbnailsBlobs[urlIndex] = 'youtube';
              }

              _this.wantToLoadSource(urlIndex);
            } else {
              alert('Invalid link to youtube video');
            }
          };

          const getVimeoIdAndSetType = function (urlIndex) {
            let regExp =
              /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i;
            let match = self.data.urls[urlIndex].match(regExp);

            if (match && match[1]) {
              self.data.urlsTypes[urlIndex] = 'vimeo';
              self.data.vimeoIDs[urlIndex] = match[1];

              if (self.data.thumbnails) {
                self.thumbnails.thumbnailsBlobs[urlIndex] = 'vimeo';
              }

              _this.wantToLoadSource(urlIndex);
            } else {
              alert('Invalid link to vimeo video');
            }
          };

          const callWantToLoadsForUrlIndex = function (urlIndex) {
            if (self.data.thumbnails) {
              _this.wantToLoadThumbnail();
            }
            _this.wantToLoadSource(urlIndex);
          };

          const setUpInvalidSourceForUrlIndex = function (urlIndex) {
            self.data.urlsTypes[urlIndex] = 'invalid';
            if (self.data.thumbnails) {
              self.thumbnails.thumbnailsBlobs[urlIndex] = 'invalid';
            }
          };
          /**
           * Check type using xhr and generete thumbnails blobs
           * @param urlIndex
           */
          this.checkWithXhr = function (urlIndex) {
            self.data.urlsTypes[urlIndex] = 'image';
            _this.blobsCounter++;
            self.thumbnails.thumbnailsBlobs[urlIndex] =
              self.data.thumbnails[urlIndex];
            callWantToLoadsForUrlIndex(urlIndex);
          };

          /**
       * if source needs to be loaded but box didn't know it's type
       or if thumbnails needs to be loaded but box don't know yet all types
       we can call load it now
       * @param urlIndex
       */
          this.wantToLoadSource = function (urlIndex) {
            if (self.data.wantToLoadSources[urlIndex]) {
              self.loadsources.loadSourceElem(urlIndex);
            }
          };

          this.wantToLoadThumbnail = function () {
            const blobs = self.thumbnails.thumbnailsBlobs;
            let everyBlobSet = true;
            for (let i = 0; i < self.data.urls.length; i++) {
              if (typeof blobs[i] === 'undefined') {
                everyBlobSet = false;
              }
            }
            if (everyBlobSet && self.data.showThumbnailsOnInit) {
              self.thumbnails.createThumbnailsElements();
            }
          };
        };
      },
      {}
    ],
    15: [
      function (require, module, exports) {
        module.exports = function (self) {
          const elements = self.elements;
          const downChangeSlideByDragging = function (e) {
            self.changeSlideByDragging.mouseDownEvent(e);
          };

          self.elements.holderWrapper.addEventListener(
            'mousedown',
            downChangeSlideByDragging
          );
          self.elements.holderWrapper.addEventListener(
            'touchstart',
            downChangeSlideByDragging,
            { passive: true }
          );

          if (self.data.hidingUI) {
            self.element.onclick = function () {
              self.hidingUI.userMoved();
            };
          }

          let upListener;
          let moveListener;
          const moveUserMove = function (e) {
            self.hidingUI.userMoved();
            moveListener(e);
          };
          const upListenerFunction = function (e) {
            self.caption.upListener();
            upListener(e);
          };

          if (self.data.thumbnails) {
            upListener = function (e) {
              self.changeSlideByDragging.mouseUpEvent(e);
              self.thumbnails.thumbnailsLogic.upListener(e);
            };
            moveListener = function (e) {
              self.changeSlideByDragging.mouseMoveEvent(e);
              self.thumbnails.thumbnailsLogic.moveListener(e);
            };
          } else {
            upListener = function (e) {
              self.changeSlideByDragging.mouseUpEvent(e);
            };
            moveListener = function (e) {
              self.changeSlideByDragging.mouseMoveEvent(e);
            };
          }

          this.addWindowListeners = function () {
            window.addEventListener('mousedown', self.caption.clearHighlight);
            window.addEventListener('mouseup', upListenerFunction);
            window.addEventListener('touchend', upListenerFunction);
            window.addEventListener('mousemove', moveUserMove);
            window.addEventListener('touchmove', moveUserMove);
          };

          this.removeWindowListeners = function () {
            window.removeEventListener(
              'mousedown',
              self.caption.clearHighlight
            );
            window.removeEventListener('mouseup', upListenerFunction);
            window.removeEventListener('touchend', upListenerFunction);
            window.removeEventListener('mousemove', moveUserMove);
            window.removeEventListener('touchmove', moveUserMove);
          };

          this.addWindowListeners();
          if (self.data.thumbnails) {
            self.thumbnails.thumbnailsBody.addEventListener(
              'mousedown',
              function (e) {
                self.thumbnails.thumbnailsLogic.downListener(e);
              }
            );
            self.thumbnails.thumbnailsBody.addEventListener(
              'touchstart',
              function (e) {
                self.thumbnails.thumbnailsLogic.downListener(e);
              },
              { passive: true }
            );
          }
        };
      },
      {}
    ],
    16: [
      function (require, module, exports) {
        module.exports = function (data) {
          this.previous = function (slide) {
            let previousSlideIndex;
            const arrayIndex = slide - 1;

            if (arrayIndex === 0) {
              previousSlideIndex = data.totalSlides - 1;
            } else {
              previousSlideIndex = arrayIndex - 1;
            }
            return previousSlideIndex;
          };

          this.next = function (slide) {
            let nextSlideIndex;
            const arrayIndex = slide - 1;

            if (slide === data.totalSlides) {
              nextSlideIndex = 0;
            } else {
              nextSlideIndex = arrayIndex + 1;
            }
            return nextSlideIndex;
          };

          this.all = function (slide) {
            // sources are stored in array indexed from 0
            const arrayIndex = slide - 1;
            const sourcesIndexes = {
              previous: 0,
              current: 0,
              next: 0
            };

            // previous
            if (arrayIndex === 0) {
              sourcesIndexes.previous = data.totalSlides - 1;
            } else {
              sourcesIndexes.previous = arrayIndex - 1;
            }

            // current
            sourcesIndexes.current = arrayIndex;

            //next
            if (slide === data.totalSlides) {
              sourcesIndexes.next = 0;
            } else {
              sourcesIndexes.next = arrayIndex + 1;
            }
            return sourcesIndexes;
          };
        };
      },
      {}
    ],
    17: [
      function (require, module, exports) {
        module.exports = function (self) {
          const _this = this;
          const data = self.data;
          const elements = self.elements;
          const sources = elements.sources;

          const getSourceData = function (sourceIndex) {
            let deviceWidth = parseInt(elements.mediaHolder.holder.style.width);
            let sourceWidth = data.sourcesDimensions[sourceIndex].width;
            let sourceHeight = data.sourcesDimensions[sourceIndex].height;
            let coefficient = sourceWidth / sourceHeight;

            return {
              deviceHeight: parseInt(elements.mediaHolder.holder.style.height),
              deviceWidth: deviceWidth,
              sourceIndex: sourceIndex,
              sourceHolder: sources[sourceIndex],
              sourceElem: sources[sourceIndex].firstChild.firstChild,
              sourceWidth: sourceWidth,
              sourceHeight: sourceHeight,
              coefficient: sourceWidth / sourceHeight,
              newHeight: deviceWidth / coefficient,
              decreaseHeightValue: 50,
              setDimensions: function (sourceHolderHeightSetter) {
                this.sourceElem.style.height = this.newHeight + 'px';
                this.sourceElem.style.width =
                  this.newHeight * this.coefficient + 'px';
                sourceHolderHeightSetter();
              }
            };
          };

          this.scaleSource = function (sourceIndex) {
            const sourceData = getSourceData(sourceIndex);
            // if there is no caption source is centered
            if (data.thumbnails) {
              if (
                !elements.captions[sourceIndex] &&
                !self.thumbnails.thumbnailsOpen
              ) {
                scaleSourceMethods.scaleSourceNoCaptionNoThumbnails(sourceData);
              } else if (
                elements.captions[sourceIndex] &&
                !self.thumbnails.thumbnailsOpen
              ) {
                scaleSourceMethods.scaleSourceCaptionNoThumbnails(sourceData);
              } else {
                scaleSourceMethods.scaleSourceThumbnails(sourceData);
              }
            } else {
              if (!elements.captions[sourceIndex]) {
                scaleSourceMethods.scaleSourceNoCaptionNoThumbnails(sourceData);
              } else {
                scaleSourceMethods.scaleSourceCaptionNoThumbnails(sourceData);
              }
            }
          };

          const scaleSourceMethods = {
            /**
             * Scale source when there is only source w/o caption or thumbnails
             * @param data
             */
            scaleSourceNoCaptionNoThumbnails: function (data) {
              const sourceHolderHeightSetter = function () {
                sources[data.sourceIndex].style.height =
                  data.deviceHeight + 'px';
              };

              // wider than higher
              if (data.newHeight < data.deviceHeight) {
                if (data.sourceWidth < data.deviceWidth) {
                  data.newHeight = data.sourceHeight;
                }
                data.setDimensions(sourceHolderHeightSetter);
                return;
              }

              // higher than wider
              if (data.sourceHeight > data.deviceHeight) {
                data.newHeight = data.deviceHeight - data.decreaseHeightValue;
              } else {
                data.newHeight = data.sourceHeight;
              }

              data.setDimensions(sourceHolderHeightSetter);
            },

            /**
             * Scale source when caption is showed
             * @param data
             */
            scaleSourceCaptionNoThumbnails: function (data) {
              const captionHeight =
                elements.captions[data.sourceIndex].offsetHeight;
              const captionDecreasedDeviceHeight =
                data.deviceHeight - captionHeight - data.decreaseHeightValue;

              const sourceHolderHeightSetter = function () {
                sources[data.sourceIndex].style.height =
                  data.deviceHeight -
                  captionHeight +
                  data.decreaseHeightValue +
                  'px';
              };

              // wider than higher
              if (data.newHeight < captionDecreasedDeviceHeight) {
                if (data.sourceWidth < data.deviceWidth) {
                  data.newHeight = data.sourceHeight;
                }
                data.setDimensions(sourceHolderHeightSetter);
                return;
              }

              // higher than wider
              if (data.sourceHeight > captionDecreasedDeviceHeight) {
                data.newHeight = captionDecreasedDeviceHeight;
              } else {
                data.newHeight = data.sourceHeight;
              }

              data.setDimensions(sourceHolderHeightSetter);
            },

            /**
             * Scale source when there are thumbnails opened (captions close then)
             * @param data
             */
            scaleSourceThumbnails: function (data) {
              const thumbnailHeight =
                self.thumbnails.thumbnailsBody.offsetHeight;
              const thumbnailDecreasedDeviceHeight =
                data.deviceHeight - thumbnailHeight - data.decreaseHeightValue;

              const sourceHolderHeightSetter = function () {
                sources[data.sourceIndex].style.height =
                  data.deviceHeight - thumbnailHeight + 'px';
              };

              // wider than higher
              if (data.newHeight < thumbnailDecreasedDeviceHeight) {
                if (data.sourceWidth < data.deviceWidth) {
                  data.newHeight = data.sourceHeight;
                }
                data.setDimensions(sourceHolderHeightSetter);
                return;
              }

              // higher than wider
              if (data.sourceHeight > thumbnailDecreasedDeviceHeight) {
                data.newHeight =
                  thumbnailDecreasedDeviceHeight -
                  0.5 * data.decreaseHeightValue;
              } else {
                data.newHeight = data.sourceHeight;
              }

              data.setDimensions(sourceHolderHeightSetter);
            }
          };

          this.transforms = function () {
            const stageSources = self.getSourcesIndexes.all(data.slide);

            for (let i in sources) {
              if (
                parseInt(i) === stageSources.previous ||
                parseInt(i) === stageSources.current ||
                parseInt(i) === stageSources.next
              ) {
                continue;
              }
              sources[i].classList.remove('fslightbox-transform-transition');
              self.transforms.transformMinus(sources[i]);
            }
          };

          this.mediaHolderDimensions = function () {
            const holderStyle = elements.mediaHolder.holder.style;
            if (window.innerHeight > 576 && window.innerWidth > 768) {
              holderStyle.height = window.innerHeight - 20 + 'px';
              holderStyle.width = window.innerWidth - 90 + 'px';
            } else {
              holderStyle.height = window.innerHeight + 'px';
              holderStyle.width = window.innerWidth + 'px';
            }
          };

          this.setSourcesDimensions = function () {
            const stageSourcesIndexes = self.getSourcesIndexes.all(data.slide);
            // add transforms to stage sources
            if (data.urls.length > 2) {
              self.transforms.transformMinus(
                sources[stageSourcesIndexes.previous]
              );
            }
            self.transforms.transformNull(sources[stageSourcesIndexes.current]);
            if (data.urls.length > 1) {
              self.transforms.transformPlus(sources[stageSourcesIndexes.next]);
            }

            for (let sourceIndex in sources) {
              this.scaleSource(sourceIndex);
            }
          };

          this.onResizeFunction = function () {
            _this.mediaHolderDimensions();
            _this.setSourcesDimensions();
            _this.transforms();
            self.slideshow.resetIncrementValue();
            if (data.thumbnails) {
              self.thumbnails.thumbnailsLogic.setThumbnailsTransforms();
            }
          };
        };
      },
      {}
    ],
    18: [
      function (require, module, exports) {
        module.exports = function (self) {
          this.addDimensionSourceTransition = function (elems) {
            elems.forEach(function (elem) {
              elem.firstChild.firstChild.style.transition =
                'width .3s, height .3s';
            });
          };

          this.removeDimensionSourceTransition = function (elems) {
            elems.forEach(function (elem) {
              elem.firstChild.firstChild.style.transition = '';
            });
          };

          /**
           * this method is called after switching slides to update slide counter DOM
           * @param number
           */
          this.updateSlideNumber = function (number) {
            self.data.slide = number;
            if (self.data.totalSlides > 1) {
              self.elements.slideCounter.innerHTML = number;
            }
          };

          this.whatWasClosed = '';

          /**
           * Method called after zooming both in and out
           * Check if user is zooming if not clears zoom and show thumbnails or captions
           */
          this.handleZoom = function () {
            const data = self.data;
            const i = data.slide - 1;
            const source = self.elements.sources[i];

            if (data.zoom !== 1) {
              data.zooming = true;
              if (!this.whatWasClosed) {
                if (data.thumbnails) {
                  self.thumbnails.thumbnailsOpen
                    ? (this.whatWasClosed = 'thumbnails')
                    : (this.whatWasClosed = 'captions');
                } else {
                  this.whatWasClosed = 'captions';
                }
              }
              self.caption.hideAllCaptions();
              if (data.thumbnails && self.thumbnails.thumbnailsOpen) {
                self.thumbnails.fadeOutThumbnails();
              }
            } else {
              this.whatWasClosed === 'thumbnails'
                ? self.thumbnails.fadeInThumbnails()
                : self.caption.showCurrentCaption();

              data.zooming = false;
              this.whatWasClosed = '';
              self.changeSlideByDragging.clearZoom();
              source.style.transition = 'transform .4s';
              source.style.transform = 'translate(0,0)';
              setTimeout(function () {
                source.style.transition = '';
              }, 400);
            }

            source.firstChild.style.transform = 'scale(' + data.zoom + ')';
          };
        };
      },
      {}
    ],
    19: [
      function (require, module, exports) {
        module.exports = function (self, slide) {
          const data = self.data;
          const elements = self.elements;
          const previousSlide = data.slide;
          data.slide = slide;
          self.othersMethods.updateSlideNumber(slide);
          const sourcesIndexes = self.getSourcesIndexes.all(slide);
          const sources = elements.sources;

          if (data.initiated && sources[slide - 1]) {
            self.appendMethods.clearAnimationOnSource(sources[slide - 1]);
            self.appendMethods.runAnimationOnSource(sources[slide - 1]);
            self.afterSlideChange();
          }

          if (data.thumbnails) {
            if (previousSlide) {
              self.thumbnails.thumbnailsLogic.switchThumbnailOnSlideChange(
                previousSlide,
                data.slide
              );
            }

            if (
              elements.captions[slide - 1] &&
              !self.thumbnails.thumbnailsOpen
            ) {
              self.caption.hideAllCaptions();
              self.caption.showCurrentCaption();
            }

            if (!elements.captions[slide - 1]) {
              self.caption.hideAllCaptions();
            }
          } else if (elements.captions[slide - 1]) {
            self.caption.hideAllCaptions();
            self.caption.showCurrentCaption();
          } else if (!elements.captions[slide - 1]) {
            self.caption.hideAllCaptions();
          }

          if (sources.length === 0) {
            self.createSources('initial', slide);
          } else {
            if (typeof sources[sourcesIndexes.previous] === 'undefined') {
              self.createSources('previous', slide);
            }

            if (typeof sources[sourcesIndexes.current] === 'undefined') {
              self.createSources('current', slide);
            }

            if (typeof sources[sourcesIndexes.next] === 'undefined') {
              self.createSources('next', slide);
            }
          }

          for (let sourceIndex in sources) {
            if (sources.hasOwnProperty(sourceIndex)) {
              sources[sourceIndex].classList.remove(
                'fslightbox-transform-transition'
              );

              // sources length needs to be higher than 1 because if there is only 1 slide
              // sourcesIndexes.previous will be 0 so it would return a bad transition
              if (
                sourceIndex == sourcesIndexes.previous &&
                sources.length > 1
              ) {
                self.transforms.transformMinus(
                  sources[sourcesIndexes.previous]
                );
                continue;
              }
              if (sourceIndex == sourcesIndexes.current) {
                self.transforms.transformNull(sources[sourcesIndexes.current]);
                continue;
              }
              if (sourceIndex == sourcesIndexes.next) {
                self.transforms.transformPlus(sources[sourcesIndexes.next]);
                continue;
              }

              self.transforms.transformMinus(sources[sourceIndex]);
            }
          }
        };
      },
      {}
    ],
    20: [
      function (require, module, exports) {
        window.fsLightboxClass = function () {
          this.data = {
            name: '',
            slide: 1,
            totalSlides: 1,
            // modifiable by user
            slideDistance: 1.3,
            slideCounter: true,
            slideButtons: true,
            /***/

            /***/
            // modifiable by user
            thumbnails: true,
            showDefaultThumbnailButton: true,
            showThumbnailsOnInit: false,
            thumbnailHighlightColor: '#b9bbbe',
            thumbnailsDistance: 10,
            /***/

            /** Slide show */
            // modifiable
            slideShowTimeout: 5000,
            slideShowBarColor: '#fff',
            /////////
            resetSlideShowOnSetSlide: false,
            /***/

            buttons: [
              //'download',
              'thumbnails',
              'slideshow',
              'zoom-in',
              'zoom-out',
              'fullscreen',
              'close'
            ],
            buttonsWithClass: [],
            buttonsClass: '',

            animationDuration: 300,
            animation: 'fade-in',
            slideAnimationDuration: 300,

            isFirstTimeLoad: false,
            moveSlidesViaDrag: true,
            buttonsElements: {},

            scrollbarWidth: 0,
            zoom: 1,
            zooming: false,

            hidingUI: true,
            timeToHideUI: 12000,
            isUIHidden: false,

            urls: [],
            urlsTypes: [],
            youtubeIDs: [],
            vimeoIDs: [],

            youtubeVideoMaxWidth: 1920,
            youtubeVideoMaxHeight: 1080,

            vimeoMaxDimensions: {
              width: 1920,
              height: 1080
            },

            /**
             * if source needs to be loaded and type is not detected yet we will add info to this array
             * so after xhr finishes it load source
             */
            wantToLoadSources: [],
            /**
         * When detecting caption offsetHeight in onResizeEvent scaleSourceCaptionNoThumbnails method it just for some
         reason doesn't detect it. There will be stored offsetHeight of all captions to fix it. All not single ones
         because detectType works after rendering captions.
         */
            captionsHeights: [],
            sourcesDimensions: [],
            videos: [],
            videosPosters: [],

            /**
         * Videos thumbnail and youtube thumbnails has different dimensions than sources
         so if we want to display video thumbnail we need to save video posters dimensions somewhere
         */
            thumbnailsAndPostersDimensions: [],

            // array which user can fill to add different thumbnails urls than sources they display
            thumbnailsUrls: [],

            svg: {
              slideButtons: {
                left: {
                  viewBox: '0 0 20 20',
                  width: '.85em',
                  height: '.85em',
                  d: 'M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z'
                },
                right: {
                  viewBox: '0 0 20 20',
                  width: '.85em',
                  height: '.85em',
                  d: 'M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z'
                }
              },
              toolbarButtons: {
                download: {
                  d: 'M 11 2 C 10.448 2 10 2.448 10 3 L 10 11 L 6 11 L 12 17 L 18 11 L 14 11 L 14 3 C 14 2.448 13.552 2 13 2 L 11 2 z M 2 20 L 2 22 L 22 22 L 22 20 L 2 20 z',
                  width: '20px',
                  height: '20px',
                  viewBox: '0 0 24 24'
                },
                thumbnails: {
                  d: 'M 3 2 C 2.448 2 2 2.448 2 3 L 2 6 C 2 6.552 2.448 7 3 7 L 6 7 C 6.552 7 7 6.552 7 6 L 7 3 C 7 2.448 6.552 2 6 2 L 3 2 z M 10 2 C 9.448 2 9 2.448 9 3 L 9 6 C 9 6.552 9.448 7 10 7 L 13 7 C 13.552 7 14 6.552 14 6 L 14 3 C 14 2.448 13.552 2 13 2 L 10 2 z M 17 2 C 16.448 2 16 2.448 16 3 L 16 6 C 16 6.552 16.448 7 17 7 L 20 7 C 20.552 7 21 6.552 21 6 L 21 3 C 21 2.448 20.552 2 20 2 L 17 2 z M 3 9 C 2.448 9 2 9.448 2 10 L 2 13 C 2 13.552 2.448 14 3 14 L 6 14 C 6.552 14 7 13.552 7 13 L 7 10 C 7 9.448 6.552 9 6 9 L 3 9 z M 10 9 C 9.448 9 9 9.448 9 10 L 9 13 C 9 13.552 9.448 14 10 14 L 13 14 C 13.552 14 14 13.552 14 13 L 14 10 C 14 9.448 13.552 9 13 9 L 10 9 z M 17 9 C 16.448 9 16 9.448 16 10 L 16 13 C 16 13.552 16.448 14 17 14 L 20 14 C 20.552 14 21 13.552 21 13 L 21 10 C 21 9.448 20.552 9 20 9 L 17 9 z M 3 16 C 2.448 16 2 16.448 2 17 L 2 20 C 2 20.552 2.448 21 3 21 L 6 21 C 6.552 21 7 20.552 7 20 L 7 17 C 7 16.448 6.552 16 6 16 L 3 16 z M 10 16 C 9.448 16 9 16.448 9 17 L 9 20 C 9 20.552 9.448 21 10 21 L 13 21 C 13.552 21 14 20.552 14 20 L 14 17 C 14 16.448 13.552 16 13 16 L 10 16 z M 17 16 C 16.448 16 16 16.448 16 17 L 16 20 C 16 20.552 16.448 21 17 21 L 20 21 C 20.552 21 21 20.552 21 20 L 21 17 C 21 16.448 20.552 16 20 16 L 17 16 z',
                  width: '17px',
                  height: '17px',
                  viewBox: '0 0 22 22'
                },
                slideshow: {
                  startD:
                    'M 6 3 A 1 1 0 0 0 5 4 A 1 1 0 0 0 5 4.0039062 L 5 15 L 5 25.996094 A 1 1 0 0 0 5 26 A 1 1 0 0 0 6 27 A 1 1 0 0 0 6.5800781 26.8125 L 6.5820312 26.814453 L 26.416016 15.908203 A 1 1 0 0 0 27 15 A 1 1 0 0 0 26.388672 14.078125 L 6.5820312 3.1855469 L 6.5800781 3.1855469 A 1 1 0 0 0 6 3 z',
                  startWidth: '17px',
                  startHeight: '17px',
                  startViewBox: '0 0 30 30',
                  pauseD:
                    'M 8 4 C 6.895 4 6 4.895 6 6 L 6 24 C 6 25.105 6.895 26 8 26 L 10 26 C 11.105 26 12 25.105 12 24 L 12 6 C 12 4.895 11.105 4 10 4 L 8 4 z M 20 4 C 18.895 4 18 4.895 18 6 L 18 24 C 18 25.105 18.895 26 20 26 L 22 26 C 23.105 26 24 25.105 24 24 L 24 6 C 24 4.895 23.105 4 22 4 L 20 4 z',
                  pauseWidth: '17px',
                  pauseHeight: '17px',
                  pauseViewBox: '0 0 30 30'
                },
                'zoom-in': {
                  d: 'M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z M 12.984375 7.9863281 A 1.0001 1.0001 0 0 0 12 9 L 12 12 L 9 12 A 1.0001 1.0001 0 1 0 9 14 L 12 14 L 12 17 A 1.0001 1.0001 0 1 0 14 17 L 14 14 L 17 14 A 1.0001 1.0001 0 1 0 17 12 L 14 12 L 14 9 A 1.0001 1.0001 0 0 0 12.984375 7.9863281 z',
                  width: '1.25em',
                  height: '1.25em',
                  viewBox: '0 0 30 30'
                },
                'zoom-out': {
                  d: 'M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z M 9 12 A 1.0001 1.0001 0 1 0 9 14 L 17 14 A 1.0001 1.0001 0 1 0 17 12 L 9 12 z',
                  width: '1.25em',
                  height: '1.25em',
                  viewBox: '0 0 30 30'
                },
                fullscreen: {
                  openD:
                    'M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z',
                  openWidth: '21px',
                  openHeight: '21px',
                  openViewBox: '0 0 17.5 18.5',
                  closeD:
                    'M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z',
                  closeWidth: '24px',
                  closeHeight: '24px',
                  closeViewBox: '0 0 950 1024'
                },
                close: {
                  d: 'M 11.469 10 l 7.08 -7.08 c 0.406 -0.406 0.406 -1.064 0 -1.469 c -0.406 -0.406 -1.063 -0.406 -1.469 0 L 10 8.53 l -7.081 -7.08 c -0.406 -0.406 -1.064 -0.406 -1.469 0 c -0.406 0.406 -0.406 1.063 0 1.469 L 8.531 10 L 1.45 17.081 c -0.406 0.406 -0.406 1.064 0 1.469 c 0.203 0.203 0.469 0.304 0.735 0.304 c 0.266 0 0.531 -0.101 0.735 -0.304 L 10 11.469 l 7.08 7.081 c 0.203 0.203 0.469 0.304 0.735 0.304 c 0.267 0 0.532 -0.101 0.735 -0.304 c 0.406 -0.406 0.406 -1.064 0 -1.469 L 11.469 10 Z',
                  width: '.95em',
                  height: '.95em',
                  viewBox: '0 0 20 20'
                }
              }
            },

            // TODO: DEPRECATED IN 1.4.2
            a: [],

            initiated: false,
            fullscreen: false,
            fadingOut: false
          };

          this.elements = {
            a: [],
            sources: [],
            captions: [],
            toolbarButtons: [],
            holderWrapper: null,
            mediaHolder: null,
            nav: null,
            toolbar: null,
            slideCounter: null,
            slideButtons: {
              left: null,
              right: null
            },
            svg: {
              slideButtons: {
                left: null,
                right: null
              },
              toolbarButtons: {
                download: null,
                thumbnails: null,
                slideshow: null,
                'zoom-in': null,
                'zoom-out': null,
                fullscreen: null,
                close: null
              }
            }
          };

          const DOMObject = require('./utils/DOMObject');
          this.element = new DOMObject('div').addClassesAndCreate([
            'fslightbox-container'
          ]);

          const self = this;

          this.init = function (initHref) {
            if (self.data.initiated) {
              self.initSetSlide(initHref);
              self.show();
              return;
            }
            self.detectData.init();
            self.detectTypes.init();
            self.renderDOM.init();
            self.caption.detectCaptionsHeights();
            if (self.data.thumbnails) {
              self.thumbnails.initThumbnails();
            }
            if (self.data.hidingUI) {
              self.hidingUI.init();
            }
            self.changeSlideByDragging.init();
            window.addEventListener('resize', function () {
              self.onResizeEvent.onResizeFunction();
            });
            self.eventListeners = new self.eventListeners(self);
            self.eventsControllers.document.keyDown.attachListener();
            document.documentElement.classList.add('fslightbox-open');
            this.scrollbarRecompensor.addRecompense();
            self.throwEvent('init');
            self.throwEvent('open');
            self.initSetSlide(initHref);
            self.data.initiated = true;
          };

          /**
           * Init can have multiple type of slides
           * @param slide
           */
          this.initSetSlide = function (slide) {
            const type = typeof slide;
            switch (type) {
              case 'string':
                self.setSlide(self.data.urls.indexOf(slide) + 1);
                break;
              case 'number':
                self.setSlide(slide);
                break;
              case 'undefined':
                self.setSlide(1);
                break;
            }
          };

          /**
           * Show dom of fsLightbox instance if exists
           */
          this.show = function () {
            const elem = self.element;
            self.scrollbarRecompensor.addRecompense();
            document.documentElement.classList.add('fslightbox-open');
            self.eventListeners.addWindowListeners();
            self.eventsControllers.document.keyDown.attachListener();
            document.body.appendChild(elem);
            if (self.data.thumbnails && self.thumbnails.areThumbnailsFadedOut) {
              self.thumbnails.fadeInThumbnails();
            }
            self.throwEvent('show');
            self.throwEvent('open');
            self.caption.switchCaptions('current');
            void self.element.offsetWidth;
            elem.style.opacity = '1';
          };

          /**
           * Closes instance
           */
          this.close = function () {
            if (self.data.fullscreen) self.toolbar.closeFullscreen();
            self.data.fadingOut = true;
            self.eventListeners.removeWindowListeners();
            self.eventsControllers.document.keyDown.removeListener();
            self.throwEvent('close');
            self.element.style.opacity = '0';
            if (self.slideshow.getIsSlideShowWorking())
              self.slideshow.slideshow();
            setTimeout(function () {
              self.scrollbarRecompensor.removeRecompense();
              document.documentElement.classList.remove('fslightbox-open');
              self.data.fadingOut = false;
              if (document.body.contains(self.element)) {
                document.body.removeChild(self.element);
              }
            }, 250);
          };

          /**
           * Create event and dispatch it to self.element
           */
          this.throwEvent = function (eventName, element) {
            let event;
            if (typeof Event === 'function') {
              event = new Event(eventName);
            } else {
              event = document.createEvent('Event');
              event.initEvent(eventName, true, true);
            }

            element
              ? element.dispatchEvent(event)
              : self.element.dispatchEvent(event);
          };

          /**
           * SVGIcon object with getSVGIcon method which return <svg> element with <path> child
           * @returns {Element}
           * @constructor
           */
          function SVGIcon(viewBox, width, height, d) {
            const svg = document.createElementNS(
              'http://www.w3.org/2000/svg',
              'svg'
            );
            const path = document.createElementNS(
              'http://www.w3.org/2000/svg',
              'path'
            );
            svg.setAttributeNS(null, 'class', 'fslightbox-svg-icon');
            svg.setAttributeNS(null, 'viewBox', '0 0 15 15');
            path.setAttributeNS(null, 'd', d);
            svg.setAttributeNS(null, 'viewBox', viewBox);
            svg.setAttributeNS(null, 'width', width);
            svg.setAttributeNS(null, 'height', height);
            svg.appendChild(path);
            return svg;
          }

          /**
           * Div that holds source elem
           */
          this.mediaHolder = function () {
            this.holder = new DOMObject('div').addClassesAndCreate([
              'fslightbox-media-holder'
            ]);

            this.renderHolder = function (container) {
              container.appendChild(this.holder);
            };
          };

          this.transforms = {
            transformMinus: function (elem) {
              elem.style.transform =
                'translate(' +
                -self.data.slideDistance * window.innerWidth +
                'px,0)';
            },

            transformNull: function (elem) {
              elem.style.transform = 'translate(0,0)';
            },

            transformPlus: function (elem) {
              elem.style.transform =
                'translate(' +
                self.data.slideDistance * window.innerWidth +
                'px,0)';
            }
          };

          /**
           * Stop videos after changing slide
           */
          this.stopVideos = function () {
            const videos = self.data.videos;
            for (let videoIndex in videos) {
              if (videos.hasOwnProperty(videoIndex)) {
                let video =
                  self.elements.sources[videoIndex].firstChild.firstChild;
                if (videos[videoIndex] === 'html') {
                  if (typeof video.pause !== 'undefined') {
                    video.pause();
                  }
                } else {
                  try {
                    video.contentWindow.postMessage(
                      '{"event":"command","func":"stopVideo","args":""}',
                      '*'
                    );
                  } catch {}
                }
              }
            }
          };

          /**
           * Method that is called on every slide change by toolbar button or by sliding
           */
          this.afterSlideChange = function () {
            self.changeSlideByDragging.clearZoom();
            self.stopVideos();
            self.elements.sources.forEach(function (source) {
              source.firstChild.style.transform = '';
            });
            if (self.data.resetSlideShowOnSetSlide) {
              self.slideshow.resetSlideShow();
            }
            if (self.data.thumbnails) {
              self.thumbnails.thumbnailsLogic.setThumbnailsTransforms();
            }
            self.throwEvent('slidechange');
          };

          new (require('./Core/ScrollbarWidthGetter'))(this.data).getWidth();
          this.scrollbarRecompensor =
            new (require('./Core/ScrollbarRecompensor'))(
              this.data.scrollbarWidth
            );

          /**
           * Render all library elements
           * @constructor
           */
          this.renderDOM = new (require('./renderDOM.js'))(self, SVGIcon);

          /**
           * Methods that contain all logi
           * @return VoidFunction
           */
          this.onResizeEvent = new (require('./helpers/onResizeEvent'))(self);

          /**
           * @function
           * @type {{previous, next, all}|*}
           */
          this.setSlide = function (slide) {
            require('./helpers/setSlide')(self, slide);
          };

          /**
       * We collect basic data from user:
       - urls
       - captions
       - video posters
       * @type {module.exports}
       */
          this.detectData = new (require('./helpers/detectData'))(self);

          /**
           * Object that takes care of detecting urls types
           */
          this.detectTypes = new (require('./helpers/detectTypes'))(self);

          /**
           * slide and zoom effects - assigned in init method
           * @type {module.exports}
           */
          this.changeSlideByDragging =
            new (require('./changeSlideByDragging.js'))(self);

          this.keyboardController =
            new (require('./Core/KeyboardController.js'))(self);

          /**
           * Activates event listeners for sliding slides (LOL) and sliding thumbnails
           * @method
           * @type Function
           */
          this.eventListeners = require('./helpers/eventListeners');

          this.eventsControllers = {
            document: {
              keyDown:
                new (require('./Core/events-controllers/DocumentKeyDownEventController'))(
                  self
                )
            }
          };

          /**
           * Return object with stage sources indexes depending on provided slide
           * @param slide
           * @returns {{previous: number, current: number, next: number}}
           */
          this.getSourcesIndexes = new (require('./helpers/getSourcesIndexes'))(
            self.data
          );

          /**
           * Toolbar at top right corner
           * @type {module.exports}
           */
          this.toolbar = new (require('./toolbar'))(self);

          /**
           * Slide show activated in toolbar
           * @type {module.exports}
           */
          this.slideshow = new (require('./components/slideshow'))(self);

          /**
           * Object that is responsible for creating and switching captions
           * @type {module.exports}
           */
          this.caption = new (require('./components/caption'))(self);

          /**
           * Thumbnails carousel if thumbnails is turn on in options (by default yes)
           * @type {module.exports}
           */
          if (self.data.thumbnails) {
            this.thumbnails = new (require('./components/thumbnails'))(
              SVGIcon,
              self
            );
          }

          /**
           * Toolbar button instance
           * @constructor
           * @param {Object} settings
           * @param {string} settings.event - Name of  dispatched event
           */
          this.toolbarButton = function (settings) {
            this.element = require('./toolbarButton')(
              SVGIcon,
              self.data.buttonsElements,
              self,
              settings
            );
          };

          /**
           * Methods that appends sources to mediaHolder depending on action
           * @type {{initialAppend, previousAppend, nextAppend}|*}
           */
          this.appendMethods = new (require('./appendMethods'))(self);

          /**
           * Create sources to stage for given slide
           * @param typeofLoad
           */
          this.createSources = function (typeofLoad, slide) {
            require('./createSources.js')(self, typeofLoad, slide);
          };

          /**
           * Display source (images, HTML5 video, YouTube video) depending on given url from user
           * Or if display is initial display 3 initial sources
           * If there are >= 3 initial sources there will be always 3 in stage
           * @param typeOfLoad
           * @param slide
           * @returns {module.exports}
           */
          this.loadsources = new (require('./loadSource.js'))(self);

          /**
           * Hiding UI when mouse event don't triggers for too long or when user is zooming
           * @type {module.exports}
           */
          this.hidingUI = new (require('./components/hidingUI'))(self);

          /**
           * Bunch of methods hard to categorize
           * @type {module.exports}
           */
          this.othersMethods = new (require('./helpers/othersMethods'))(self);
        };

        !(function () {
          window.fsLightboxInstances = [];
          window.fsLightboxHelpers = {
            a: document.getElementsByTagName('a')
          };

          let a = fsLightboxHelpers.a;

          for (let i = 0; i < a.length; i++) {
            const instanceName = a[i].getAttribute('data-fslightbox');

            if (instanceName === null) {
              continue;
            }

            if (typeof fsLightboxInstances[instanceName] === 'undefined') {
              window.fsLightbox = new fsLightboxClass();
              window.fsLightbox.data.name = instanceName;
              fsLightboxInstances[instanceName] = window.fsLightbox;
            }

            fsLightboxInstances[instanceName].elements.a.push(a[i]);
            fsLightboxInstances[instanceName].data.a.push(a[i]);

            a[i].addEventListener('click', function (e) {
              e.preventDefault();
              if (fsLightboxInstances[instanceName].data.initiated) {
                fsLightboxInstances[instanceName].show();
                fsLightboxInstances[instanceName].setSlide(
                  fsLightboxInstances[instanceName].data.urls.indexOf(
                    this.getAttribute('href')
                  ) + 1
                );
                return;
              }
              fsLightboxInstances[instanceName].init(this.getAttribute('href'));
            });
          }
        })(document, window);
      },
      {
        './Core/KeyboardController.js': 1,
        './Core/ScrollbarRecompensor': 2,
        './Core/ScrollbarWidthGetter': 3,
        './Core/events-controllers/DocumentKeyDownEventController': 4,
        './appendMethods': 5,
        './changeSlideByDragging.js': 6,
        './components/caption': 7,
        './components/hidingUI': 8,
        './components/slideshow': 9,
        './components/thumbnails': 10,
        './createSources.js': 12,
        './helpers/detectData': 13,
        './helpers/detectTypes': 14,
        './helpers/eventListeners': 15,
        './helpers/getSourcesIndexes': 16,
        './helpers/onResizeEvent': 17,
        './helpers/othersMethods': 18,
        './helpers/setSlide': 19,
        './loadSource.js': 21,
        './renderDOM.js': 22,
        './toolbar': 23,
        './toolbarButton': 24,
        './utils/DOMObject': 25
      }
    ],
    21: [
      function (require, module, exports) {
        module.exports = function (self) {
          const sources = self.elements.sources;
          const DOMObject = require('./utils/DOMObject');

          this.loadSourceElem = function (sourceIndex) {
            const type = self.data.urlsTypes[sourceIndex];
            if (!type) {
              self.data.wantToLoadSources[sourceIndex] = true;
              return;
            }

            switch (type) {
              case 'image':
                loadImage(sourceIndex);
                break;
              case 'video':
                loadVideo(sourceIndex);
                break;
              case 'youtube':
                loadYoutubeVideo(sourceIndex);
                break;
              case 'vimeo':
                loadVimeoVideo(sourceIndex);
                break;
              case 'invalid':
                this.invalidFile(sourceIndex);
                break;
            }
          };

          const loadImage = function (sourceIndex) {
            const sourceElem = new DOMObject('img').addClassesAndCreate([
              'fslightbox-single-source'
            ]);
            sourceElem.src = self.data.urls[sourceIndex];
            sourceElem.alt = self.data.altAttributes[sourceIndex];
            sourceElem.addEventListener('load', function () {
              onloadListener(sourceElem, this.width, this.height, sourceIndex);
            });

            sourceElem.addEventListener('contextmenu', (e) => {
              if (self.data.imageCopyProtection) e.preventDefault();
            });
          };

          const loadYoutubeVideo = function (sourceIndex) {
            self.data.videos[sourceIndex] = 'youtube';

            const iframe = buildIFrame();
            iframe.src =
              '//www.youtube.com/embed/' +
              self.data.youtubeIDs[sourceIndex] +
              '?enablejsapi=1';

            self.elements.mediaHolder.holder.appendChild(iframe);
            onloadListener(
              iframe,
              self.data.youtubeVideoMaxWidth,
              self.data.youtubeVideoMaxHeight,
              sourceIndex
            );
          };

          const loadVimeoVideo = function (sourceIndex) {
            self.data.videos[sourceIndex] = 'vimeo';

            const iframe = buildIFrame();
            iframe.src =
              '//player.vimeo.com/video/' + self.data.vimeoIDs[sourceIndex];

            self.elements.mediaHolder.holder.appendChild(iframe);
            onloadListener(
              iframe,
              self.data.youtubeVideoMaxWidth,
              self.data.youtubeVideoMaxHeight,
              sourceIndex
            );
          };

          const buildIFrame = () => {
            const iframe = document.createElement('iframe');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('frameborder', '0');
            iframe.className = 'fslightbox-source';
            return iframe;
          };

          const loadVideo = function (sourceIndex) {
            self.data.videos[sourceIndex] = 'html';
            let videoLoaded = false;
            const videoElem = new DOMObject('video').addClassesAndCreate([
              'fslightbox-single-source'
            ]);
            const source = new DOMObject('source').elem;
            source.src = self.data.urls[sourceIndex];
            if (self.data.videosPosters[sourceIndex]) {
              videoElem.poster = self.data.videosPosters[sourceIndex];
              videoElem.style.objectFit = 'cover';
            }
            videoElem.appendChild(source);
            let width;
            let height;
            videoElem.onloadedmetadata = function () {
              if (videoLoaded) {
                return;
              }
              // if browser don't support videoWidth and videoHeight we need to add default ones
              if (!this.videoWidth || this.videoWidth === 0) {
                width = 1920;
                height = 1080;
              } else {
                width = this.videoWidth;
                height = this.videoHeight;
              }
              videoLoaded = true;
              onloadListener(videoElem, width, height, sourceIndex);
            };

            // if browser don't supprt both onloadmetadata or .videoWidth we will load it after 3000ms
            let counter = 0;

            // ON IE on load event dont work so we need to wait for dimensions with setTimeouts
            let IEFix = setInterval(function () {
              if (videoLoaded) {
                clearInterval(IEFix);
                return;
              }
              if (!videoElem.videoWidth || videoElem.videoWidth === 0) {
                if (counter < 31) {
                  counter++;
                  return;
                } else {
                  width = 1920;
                  height = 1080;
                }
              } else {
                width = videoElem.videoWidth;
                height = videoElem.videoHeight;
              }

              videoLoaded = true;
              onloadListener(videoElem, width, height, sourceIndex);
              clearInterval(IEFix);
            }, 100);

            videoElem.setAttribute('controls', '');
          };

          this.invalidFile = function (sourceIndex) {
            const invalidFileWrapper = new DOMObject('div').addClassesAndCreate(
              ['fslightbox-invalid-file-wrapper']
            );
            invalidFileWrapper.innerHTML = 'Invalid file';
            onloadListener(
              invalidFileWrapper,
              window.innerWidth,
              window.innerHeight,
              sourceIndex
            );
          };

          /**
           * Append source to source holder
           * @param sourceIndex
           * @param sourceElem
           */
          let appendSourceToHolder = function (sourceIndex, sourceElem) {
            const sourceHolder = sources[sourceIndex];
            sourceHolder.firstChild.innerHTML = '';
            sourceHolder.firstChild.appendChild(sourceElem);
            self.appendMethods.runAnimationOnSource(sourceHolder);
          };

          /**
           * add fade in class and dimension function
           */
          let onloadListener = function (
            sourceElem,
            sourceWidth,
            sourceHeight,
            sourceIndex
          ) {
            //normal source dimensions needs to be stored in array
            //it will be needed when resizing a source
            self.data.sourcesDimensions[sourceIndex] = {
              width: sourceWidth,
              height: sourceHeight
            };

            const wrapper = document.createElement('div');
            wrapper.classList.add('fslightbox-single-source-wrapper');
            wrapper.appendChild(sourceElem);

            const watermarkLogo = document.createElement('div');
            wrapper.appendChild(watermarkLogo);
            const img = document.createElement('img');
            img.setAttribute('alt', '');
            const imgFilter = document.createElement('div');
            imgFilter.classList.add(
              `eapp-photo-gallery-item-data-watermarkLogoFilter`
            );
            const updateWatermarkLogo = (
              text,
              position,
              fontSizeConst = 8,
              watermarkType,
              imageUrl,
              watermarkLogoSize
            ) => {
              const width = wrapper.getBoundingClientRect().width;

              if (watermarkType === 'text') {
                watermarkLogo.innerHTML = text;
                const fontSize = 8 + 0.001 * width * fontSizeConst + 'px';
                watermarkLogo.style.fontSize = fontSize;
              } else {
                const logoWidth = 40 + 0.002 * width * watermarkLogoSize;
                img.style.width = logoWidth + 'px';
                if (!imageUrl) {
                  watermarkLogo.innerHTML = '';
                  return;
                }

                if (img.getAttribute('src') !== imageUrl) {
                  img.setAttribute('src', imageUrl);
                }
                if (!imgFilter.parentElement) {
                  imgFilter.innerHTML = '';
                  imgFilter.appendChild(img);
                  watermarkLogo.innerHTML = '';
                  watermarkLogo.appendChild(imgFilter);
                }
              }
              watermarkLogo.className = '';
              watermarkLogo.classList.add(
                'eapp-photo-gallery-item-data-watermarkLogo'
              );
              watermarkLogo.classList.add(
                `eapp-photo-gallery-item-data-watermarkPosition-${position}`
              );
            };

            self.data.updateWatermarkFunctions.push(updateWatermarkLogo);

            appendSourceToHolder(sourceIndex, wrapper);
            // set dimensions for the 1st time
            self.onResizeEvent.scaleSource(sourceIndex, sourceElem);
            updateWatermarkLogo(
              self.data.watermarkText,
              self.data.watermarkPosition,
              self.data.watermarkTextSize,
              self.data.watermarkType,
              self.data.watermarkUrl,
              self.data.watermarkLogoSize
            );
          };
        };
      },
      { './utils/DOMObject': 25 }
    ],
    22: [
      function (require, module, exports) {
        module.exports = function (self, SVGIcon) {
          const slideButtonsData = self.data.svg.slideButtons;
          const elements = self.elements;
          const DOMObject = require('./utils/DOMObject');

          function SlideCounter() {
            const slideNumberClass = 'fslightbox-slide-slide-number';
            const numberContainer = new DOMObject('div').addClassesAndCreate([
              'fslightbox-slide-number-container'
            ]);
            elements.slideCounter = new DOMObject('div').addClassesAndCreate([
              slideNumberClass
            ]);

            elements.slideCounter.innerHTML = self.data.slide;
            elements.slideCounter.id = 'current_slide';

            const space = new DOMObject('div').addClassesAndCreate([
              slideNumberClass,
              'fslightbox-slash'
            ]);
            space.innerHTML = '/';

            const slides = new DOMObject('div').addClassesAndCreate([
              slideNumberClass
            ]);
            slides.innerHTML = self.data.totalSlides;

            numberContainer.appendChild(elements.slideCounter);
            numberContainer.appendChild(space);
            numberContainer.appendChild(slides);

            this.renderSlideCounter = function (nav) {
              if (self.data.slideCounter) {
                nav.appendChild(numberContainer);
              }
            };
          }

          const renderNav = function (container) {
            elements.nav = new DOMObject('div').addClassesAndCreate([
              'fslightbox-nav'
            ]);
            self.toolbar.renderToolbar(elements.nav);
            if (self.data.totalSlides > 1) {
              const slideCounter = new SlideCounter();
              slideCounter.renderSlideCounter(elements.nav);
            }
            container.appendChild(elements.nav);
          };

          const renderSlideButtons = function (container) {
            if (self.data.slideButtons === false) {
              return;
            }
            createBTN(container, 'left', function () {
              self.appendMethods.previousSlideViaButton(self.data.slide);
            });
            createBTN(container, 'right', function () {
              self.appendMethods.nextSlideViaButton(self.data.slide);
            });
          };

          const createBTN = function (container, name, onClick) {
            const slideButtonData = slideButtonsData[name];
            elements.svg.slideButtons[name] = new SVGIcon(
              slideButtonData.viewBox,
              slideButtonData.width,
              slideButtonData.height,
              slideButtonData.d
            );
            const slideButtonContainer = new DOMObject(
              'div'
            ).addClassesAndCreate([
              'fslightbox-slide-btn-container',
              'fslightbox-slide-btn-' + name + '-container'
            ]);
            slideButtonContainer.onclick = onClick;
            elements.slideButtons[name] = new DOMObject(
              'div'
            ).addClassesAndCreate(['fslightbox-slide-btn', 'button-style']);
            elements.slideButtons[name].appendChild(
              elements.svg.slideButtons[name]
            );
            slideButtonContainer.appendChild(elements.slideButtons[name]);
            container.appendChild(slideButtonContainer);
          };

          this.init = function () {
            self.element.id = 'fslightbox-container';
            document.body.appendChild(self.element);

            //render slide buttons and nav(toolbar)
            renderNav(self.element);

            if (self.data.totalSlides > 1) {
              renderSlideButtons(self.element);
            }

            elements.holderWrapper = new DOMObject('div').addClassesAndCreate([
              'fslightbox-holder-wrapper'
            ]);
            self.element.appendChild(elements.holderWrapper);
            elements.mediaHolder = new self.mediaHolder();
            self.onResizeEvent.mediaHolderDimensions();
            elements.mediaHolder.renderHolder(elements.holderWrapper);
            self.data.isfirstTimeLoad = true;
          };
        };
      },
      { './utils/DOMObject': 25 }
    ],
    23: [
      function (require, module, exports) {
        module.exports = function (self) {
          const data = self.data;
          const _this = this;
          const elements = self.elements;

          this.toolbarElem = new (require('./utils/DOMObject'))(
            'div'
          ).addClassesAndCreate(['fslightbox-toolbar']);

          this.renderDefaultButtons = function () {
            const toolbarButtonsData = self.data.svg.toolbarButtons;
            const slideShowButtonData = toolbarButtonsData.slideshow;
            const fullscreenButtonData = toolbarButtonsData.fullscreen;

            if (data.thumbnails) {
              ifButtonIsChosenCreateItFromNameAndOnClick(
                'thumbnails',
                function () {
                  if (data.thumbnails) {
                    self.thumbnails.hideShowThumbnails();
                  }
                }
              );
            }

            // slideshow is created normally because we use here special d attribute
            if (self.data.buttons.indexOf('slideshow') >= 0) {
              new self.toolbarButton({
                name: 'slideshow',
                viewBox: slideShowButtonData.startViewBox,
                width: slideShowButtonData.startWidth,
                height: slideShowButtonData.startHeight,
                d: slideShowButtonData.startD,
                onclick: function () {
                  self.slideshow.slideshow();
                }
              });
            }

            ifButtonIsChosenCreateItFromNameAndOnClick('zoom-in', function () {
              data.zoom += 0.25;
              self.othersMethods.handleZoom();
            });

            ifButtonIsChosenCreateItFromNameAndOnClick('zoom-out', function () {
              if (data.zoom === 0) return;
              data.zoom -= 0.25;
              self.othersMethods.handleZoom();
            });

            if (self.data.buttons.indexOf('fullscreen') >= 0) {
              new self.toolbarButton({
                name: 'fullscreen',
                viewBox: fullscreenButtonData.openViewBox,
                width: fullscreenButtonData.openWidth,
                height: fullscreenButtonData.openHeight,
                d: fullscreenButtonData.openD,
                onclick: function () {
                  data.fullscreen
                    ? _this.closeFullscreen()
                    : _this.openFullscreen();
                }
              });
            }

            ifButtonIsChosenCreateItFromNameAndOnClick('close', function () {
              if (!data.fadingOut) self.close();
            });

            ifButtonIsChosenCreateItFromNameAndOnClick('download', function () {
              const urlIndex = data.slide - 1;
              const type = data.urlsTypes[urlIndex];
              if (type === 'youtube' || type === 'invalid') return;
              let url = data.urls[urlIndex];
              let link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', '');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
          };

          const ifButtonIsChosenCreateItFromNameAndOnClick = function (
            name,
            onClick
          ) {
            if (self.data.buttons.indexOf(name) >= 0) {
              createButtonFromDataForDataAndOnClick(name, onClick);
            }
          };

          const createButtonFromDataForDataAndOnClick = function (
            name,
            onClick
          ) {
            const buttonData = self.data.svg.toolbarButtons[name];
            new self.toolbarButton({
              name: name,
              viewBox: buttonData['viewBox'],
              width: buttonData['width'],
              height: buttonData['height'],
              d: buttonData['d'],
              onclick: onClick
            });
          };

          this.openFullscreen = function () {
            data.fullscreen = true;
            const fullscreenButton = elements.svg.toolbarButtons.fullscreen;
            const fullscreenButtonData = data.svg.toolbarButtons.fullscreen;
            fullscreenButton.firstChild.setAttributeNS(
              null,
              'd',
              fullscreenButtonData.closeD
            );
            fullscreenButton.setAttributeNS(
              null,
              'viewBox',
              fullscreenButtonData.closeViewBox
            );
            fullscreenButton.setAttributeNS(
              null,
              'width',
              fullscreenButtonData.closeWidth
            );
            fullscreenButton.setAttributeNS(
              null,
              'height',
              fullscreenButtonData.closeHeight
            );
            let elem = document.documentElement;
            if (elem.requestFullscreen) {
              elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) {
              elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
              elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
              elem.msRequestFullscreen();
            }
          };

          this.closeFullscreen = function () {
            data.fullscreen = false;
            const fullscreenButton = elements.svg.toolbarButtons.fullscreen;
            const fullscreenButtonData = data.svg.toolbarButtons.fullscreen;
            fullscreenButton.firstChild.setAttributeNS(
              null,
              'd',
              fullscreenButtonData.openD
            );
            fullscreenButton.setAttributeNS(
              null,
              'viewBox',
              fullscreenButtonData.openViewBox
            );
            fullscreenButton.setAttributeNS(
              null,
              'width',
              fullscreenButtonData.openWidth
            );
            fullscreenButton.setAttributeNS(
              null,
              'height',
              fullscreenButtonData.openHeight
            );
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            }
          };

          this.renderToolbar = function (nav) {
            this.renderDefaultButtons();
            const buttonsData = self.data.buttons;

            try {
              for (let i = 0; i < buttonsData.length; i++) {
                if (
                  buttonsData[i] === 'thumbnails' &&
                  data.thumbnails === false
                ) {
                  continue;
                }
                if (data.buttonsWithClass.indexOf(buttonsData[i]) >= 0) {
                  self.elements.toolbarButtons[buttonsData[i]].classList.add(
                    data.buttonsClass
                  );
                }
                _this.toolbarElem.appendChild(
                  self.elements.toolbarButtons[buttonsData[i]]
                );
              }
            } catch (e) {
              alert(
                'Fullscreen Lightbox Error - Toolbar buttons list is invalid!'
              );
            }
            nav.appendChild(_this.toolbarElem);
          };
        };
      },
      { './utils/DOMObject': 25 }
    ],
    24: [
      function (require, module, exports) {
        module.exports = function (SVGIcon, buttonsElements, self, settings) {
          const button = new (require('./utils/DOMObject'))(
            'div'
          ).addClassesAndCreate(['fslightbox-toolbar-button', 'button-style']);
          self.elements.svg.toolbarButtons[settings.name] = new SVGIcon(
            settings.viewBox,
            settings.width,
            settings.height,
            settings.d
          );
          button.appendChild(self.elements.svg.toolbarButtons[settings.name]);
          button.onclick = settings.onclick;
          button.title =
            settings.name.charAt(0).toUpperCase() + settings.name.slice(1);

          // optional parameters
          if (settings.classes) {
            settings.classes.forEach(function (singleClass) {
              button.classList.add(singleClass);
            });
          }
          if (settings.id) {
            button.id = settings.id;
          }

          self.elements.toolbarButtons[settings.name] = button;
          return button;
        };
      },
      { './utils/DOMObject': 25 }
    ],
    25: [
      function (require, module, exports) {
        module.exports = function (tag) {
          this.elem = document.createElement(tag);

          this.addClassesAndCreate = function (classes) {
            for (let index in classes) {
              if (classes.hasOwnProperty(index)) {
                this.elem.classList.add(classes[index]);
              }
            }
            return this.elem;
          };
        };
      },
      {}
    ]
  },
  {},
  [20]
);
